/* eslint-disable react/prop-types */
import React, { useEffect, useMemo, useState } from 'react';
import { ListPaymentMethodAll, MOBILE, apiUrlB2B, deliveryId, timeout, uniqueID, vaBca, minimumAmountBca, PAYMENT_UI_CONFIG, VOUCHER_GLOBAL_PURPOSE, baseUrl } from '../../utils/constants';
import { addCountryCode, axiosInstance, calculateAddonPackagingFee, checkScope, dateToUnix, encodeValue, formatRupiah, getSecondsLeft, isEmptyData, sendAnalyticsCustomEvent, sendAnalyticsEvent, sendAnalyticsPageView, sortVouchers, trackMetaPixelEvent, unixToDate, cleanText, authHeaders } from '../../utils/helper';
import { ArrowLeftIcon, ArrowRightIcon, CheckCircleIcon } from '@heroicons/react/24/solid';
import { HeartIcon, ChevronRightIcon, ChevronDownIcon, ChevronUpIcon } from '@heroicons/react/24/outline';
import { AutoVoucherIcon, BGVoucherIcon, DiscountIcon, DoubleNoteIcon, LoaderIcon, MotorbikeIcon, TicketDiscountIcon, UltraVoucherIcon } from '../../utils/svg';
import Footer from '../../components/Footer';
import qs from 'qs';
import CartDetail from '../../components/Cart';
import Voucher from '../../components/Voucher';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import TooltipInfo from '../../components/TooltipInfo';
import VoucherDetail from '../../components/Voucher/VoucherDetail';
import VoucherGlobalDetail from '../../components/VoucherGlobal/VoucherDetail';
import { BottomSheet } from 'react-spring-bottom-sheet';
import ProductSimple from '../../components/Product/simple';
import { ComboDetail } from '../../components/Product/combo';
import { useDispatch, useSelector } from 'react-redux';
import { setUser } from '../../store/reducers/user';
import { clearPayment, setPayment } from '../../store/reducers/payment';
import { HowToSetPinUltraValue, SetPinUltraValue, TooFar } from '../../components/Errors';
import Loader from '../../components/Loader';
import { listPaymentMethod } from '../../utils/constants';
import VerifyPin from '../../components/VerifyPin';
import VerifyVoucher from '../../components/VerifyVoucher';
import useNavigation from '../../hook/useNavigation';
import Delivery from '../../components/Delivery';
import VoucherGlobal from '../../components/VoucherGlobal';
import PromoCode from '../../components/PromoCode';
import OrderOption from '../../components/OrderOption';
import OutletDetail from '../../components/Summary/OutletDetail';
import ImageLoader from '../../components/ImageLoader';
import moment from 'moment-timezone';
import OutletClosedCard from '../../components/Outlet/OutletClose';
import { showError, subscribeError } from '../../ufood-x/hook/useError';
import CheckoutSlider from '../../components/CheckoutSlider';
import axios from 'axios';
import TableNumber from '../../ufood-x/components/Outlet/TableNumber';

const VoucherOption = ({
	isLoadingVoucherList = false,
	maxNominalVoucher = 0,
	totalSavedB2BVoucher = 0,
	handleApplyB2BVoucher = () => {},
	isLoading = false,
	totalNominalVoucher = 0,
	totalNominalB2BVoucher = 0,
	totalNominalVoucherGlobal = 0,
	setIsShowBottomSheet = () => {},
	setIsShowVoucher = () => {},
}) => {
	const user = useSelector((store) => store?.user || {});
  
  const defaultColor = 'bg-gradient-to-r from-[var(--purplish-pink)] to-[var(--purplish-pink)]';
  const b2cApplyColor = 'bg-gradient-to-r from-green-600 via-green-700/70 to-green-500';
  const b2bApplyColor = 'bg-gradient-to-r from-[var(--rose-violet)] to-[var(--rose-violet)]';
	return (
		<div className='w-full h-full flex flex-col my-4'>
			<div className='mx-4 flex flex-col border-1 border-solid border-gray-200 rounded-xl'>
				<div className='flex flex-row justify-between relative min-h-16 h-fit items-center'>
					{isLoadingVoucherList ? (
						<div className='z-[1] w-full flex items-center justify-center'>
							<LoaderIcon />
						</div>
					) : (
						<div className='flex flex-row pl-2 items-center z-[1]'>
							<AutoVoucherIcon />
							<div className='pl-2 h-full'>
								{Boolean(maxNominalVoucher) ? (
									<div className='text-white font-normal text-sm break-words'>Baik, Voucher Anda sudah terpakai</div>
								) : (
									<div className='text-white font-normal text-sm break-words'>Masukkan Voucher Anda di sini</div>
								)}
								{Boolean(totalSavedB2BVoucher) ? (
									<div className='text-white font-thin text-xxs pt-1 break-words'>Total nilai voucher {formatRupiah(totalSavedB2BVoucher)}</div>
								) : Boolean(maxNominalVoucher) ? (
									<div className='text-white font-thin text-xxs pt-1 break-words'>Total nilai voucher {formatRupiah(maxNominalVoucher)}</div>
								) : (
									<div className='text-white font-thin text-xxs pt-1 break-words'>Maksimalkan diskon dengan Voucher ini sekarang</div>
								)}
							</div>
						</div>
					)}
					{!isLoadingVoucherList ? (
						Boolean(totalSavedB2BVoucher) ? (
							<button
								id='summary_apply_b2b_voucher'
								onClick={() => {
									handleApplyB2BVoucher();
								}}
								disabled={isLoading}
								className='bg-white px-4 py-2 mr-4 rounded-lg border-[var(--rose-violet)] text-[var(--rose-violet)] font-semibold min-w-fit'>
								Gunakan
							</button>
						) : totalNominalVoucher || totalNominalB2BVoucher || totalNominalVoucherGlobal ? (
							<CheckCircleIcon className={`h-7 w-7 z-[1] mr-4 text-green-600 `} />
						) : null
					) : null}
          <BGVoucherIcon className={`h-full w-full absolute rounded-lg !z-0 ${user?.is_b2b ? b2bApplyColor : b2cApplyColor}`} />
				</div>
				{!isLoadingVoucherList && (
					<div
						id='summary_view_voucher_menu'
						className='flex justify-between items-center my-4 mx-4'
						onClick={() => {
							setIsShowBottomSheet(true);
							setIsShowVoucher(true);
						}}>
						<div className='text-gray-600 font-semibold text-sm'>Lihat voucher lainnya</div>
						<div className='h-6 w-6 flex justify-end cursor-pointer'>
							<ArrowRightIcon class='h-6 w-6 text-gray-700' />
						</div>
					</div>
				)}
			</div>
		</div>
	);
};

const UltraVoucher = ({ payment = {}, isLowBalanceUltraValue = false, isLoadingCheckPinUltraValue = false, UVBalance = {}, values = {} }) => {
	const navigate = useNavigation();

	const isUltraVoucher = payment?.code === 'ULTRA-VOUCHER';
	const isLowBalance = isUltraVoucher && isLowBalanceUltraValue;
	return (
		<>
			<div className={`flex items-center ${isLowBalance && 'opacity-50'}`}>
				<UltraVoucherIcon />
				<div className='pl-2'>
					<div className={`text-xs capitalize font-semibold text-gray-900`}>{`${payment?.name}`}</div>
					{isLoadingCheckPinUltraValue ? (
						<LoaderIcon />
					) : (
						<div className={`text-xs pt-1 font-thin ${isLoadingCheckPinUltraValue ? 'text-red-700' : 'text-gray-700'}`}>
							{isLoadingCheckPinUltraValue ? `Ultra Value is currently unavailable.` : `Balance ${formatRupiah(UVBalance?.value || 0)}`}
						</div>
					)}
					{isLowBalanceUltraValue && <div className={`text-xs pt-1 font-thin text-red-700`}>Saldo Anda tidak mencukupi</div>}
				</div>
			</div>
			<div className='flex flex-row items-center'>
				<div
					onClick={() => {
						sendAnalyticsCustomEvent('topup_ultra_value');
						trackMetaPixelEvent('topup_ultra_value');
						navigate.push({
							pathname: '/ultra-value',
							state: {
								balance: UVBalance?.value ?? 0,
							},
						})
					}}
					className='text-[var(--rose-violet)] border-1 border-solid py-1 px-2 rounded-md text-xs font-semibold'>
					Top Up
				</div>
				<div className={`pl-2 ${isLowBalance && 'opacity-50'}`}>
					<input
						id='payment'
						type='radio'
						name='payment'
						value={payment?.code}
						checked={values?.paymentType?.code === payment?.code}
						onChange={() => null}
						disabled={isLoadingCheckPinUltraValue || isLowBalanceUltraValue}
						className={`${values?.paymentType?.code === payment?.code ? '!border-[var(--rose-violet)]' : '!border-gray-400'} after:!bg-[var(--rose-violet)] active:bg-white focus:bg-transparent focus:!shadow-none`}
					/>
				</div>
			</div>
		</>
	);
};

const ListPaymentMethod = ({ method = {}, index = 0, isLowBalanceUltraValue = false, isLoadingCheckPinUltraValue = false, values = {}, setValues = () => {}, UVBalance = {} }) => {
	return (
		<div key={index} className='w-full'>
			<div className='flex justify-start py-4 text-sm text-gray-800 font-semibold capitalize'>{method?.category ?? ''}</div>
			{method?.payment_method?.map((payment, index) => {
				const isUltraVoucher = payment?.code === 'ULTRA-VOUCHER';
				const isDisabled = isUltraVoucher && isLoadingCheckPinUltraValue;
				const isLowBalance = isUltraVoucher && isLowBalanceUltraValue;
				return (
					<div
						id={payment?.event}
						key={`payment_${index}`}
						className={`border-1 border-gray-300 border-solid rounded-md flex justify-between px-2 py-2.5 mt-2 items-center min-h-14`}
						onClick={() => {
							if (isDisabled || isLowBalance) return;
							setValues((prev) => {
								return {
									...prev,
									paymentType: payment,
								};
							});
						}}>
						{isUltraVoucher ? (
							<UltraVoucher payment={payment} isLowBalanceUltraValue={isLowBalanceUltraValue} isLoadingCheckPinUltraValue={isLoadingCheckPinUltraValue} UVBalance={UVBalance} values={values} />
						) : (
							<>
								<div className='flex items-center'>
                  <ImageLoader alt={payment?.alt ?? ''} src={payment?.image_url} className={payment?.image_size || 'w-9 h-auto max-h-9'} />
									{/* <img alt={payment?.alt ?? ''} src={payment?.image_url} className={payment?.image_size || 'w-9 h-auto'} /> */}
									<div className='pl-2'>
										<div className={`text-xs capitalize font-semibold text-gray-900`}>{`${payment?.name}`}</div>
									</div>
								</div>
								<div className='flex flex-row items-center'>
									<div className='pl-2'>
										<input
											id='payment'
											type='radio'
											name='payment'
											value={payment?.code}
											checked={values?.paymentType?.code === payment?.code}
											onChange={() => null}
											className={`${values?.paymentType?.code === payment?.code ? '!border-[var(--rose-violet)]' : '!border-gray-400'} after:!bg-[var(--rose-violet)] active:bg-white focus:bg-transparent`}
										/>
									</div>
								</div>
							</>
						)}
					</div>
				);
			})}
		</div>
	);
};

const PaymentMethod = ({
	isShowPaymentMethod = false,
	paymentMethodList = [],
	setIsShowPaymentMethod = () => {},
	setIsShowBottomSheet = () => {},
	isLowBalanceUltraValue = false,
	isLoadingCheckPinUltraValue = false,
	values = {},
	setValues = () => {},
	UVBalance = {},
}) => {
	return (
		<>
			<div className={`bg-white p-4 shadow-custom transition-transform duration-1000 ease-in-out rounded-t-xl h-full max-h-[60vh] overflow-y-scroll scrollbar-hide ${isShowPaymentMethod ? 'translate-y-0 relative' : 'translate-y-full hidden'}`}>
				<div className='flex justify-center py-4 text-base text-gray-900 font-semibold'>Pilih Metode Pembayaran</div>
				{paymentMethodList?.map((method, index) => {
					return (
						<ListPaymentMethod
							key={index}
							method={method}
							index={index}
							isLowBalanceUltraValue={isLowBalanceUltraValue}
							isLoadingCheckPinUltraValue={isLoadingCheckPinUltraValue}
							values={values}
							setValues={setValues}
							UVBalance={UVBalance}
						/>
					);
				})}
			</div>
			<div className='!bg-white w-full p-4 z-auto shadow-custom'>
				<button
					id='payment_methods_choose'
					className='mt-2 w-full bg-[var(--rose-violet)] text-white flex justify-center font-normal text-sm p-3 border-0 items-center'
					onClick={() => {
						setIsShowPaymentMethod(false);
						setIsShowBottomSheet(false);
					}}>
					Pilih Pembayaran
				</button>
			</div>
		</>
	);
};

const Header = ({ outlet = {}, cart = {}, handleFavorite = () => {} }) => {
	const navigate = useNavigation();

	return (
		<div className='flex flex-row justify-between mx-4 border-b-1 border-solid pb-2 border-gray-200'>
			<div className='flex justify-center items-center cursor-pointer' onClick={() => (isEmptyData(outlet?.storeSlug) ? navigate.back() : navigate.push(`/outlet/${outlet?.storeSlug}/delivery`))} id='summary_back'>
				<ArrowLeftIcon className='h-8 w-8 min-h-8 text-gray-900 p-1.5' />
				<div className='pl-2 text-base text-gray-900 font-semibold truncate max-w-[75vw]'>{cart?.store?.storeName ?? ''}</div>
			</div>
			<div className='flex gap-2'>
				<div className='flex justify-center items-center cursor-pointer' onClick={handleFavorite}>
					<HeartIcon className={`h-8 w-8 ${Boolean(Number(outlet?.favorite || outlet?.favourite)) ? 'fill-red-500 text-red-500' : 'text-gray-900'} p-1.5`} />
				</div>
			</div>
		</div>
	);
};

const DeliveryOption = (props) => {
  const { errors = null, touched = null, values = {}, isOpenDelivery, onClose, handleOpen } = props;
	const user = useSelector((store) => store?.user);

	return (
		<>
			<div className={`mx-4 mt-4 flex justify-between items-center ${values?.orderType !== "delivery" ? 'hidden' : ''}`}>
				<div>
					<div className='text-xs text-gray-900 font-semibold'>Lokasi Pengiriman</div>
					<div className='text-sm text-gray-900 font-semibold pt-2 max-w-64 overflow-ellipsis line-clamp-2'>{user?.address}</div>
				</div>
				<button
					id='summary_change_location'
					className={`${
						errors?.destinations?.address && touched?.destinations?.address ? 'border-red-500 text-red-500' : 'border-[var(--rose-violet)] text-[var(--rose-violet)]'
					} bg-white border-solid border-1 py-2 px-4 text-xs font-semibold rounded-md min-w-fit`}
					onClick={handleOpen}>
					Ubah
				</button>
			</div>
			<BottomSheet
				key={'delivery-location'}
				open={isOpenDelivery}
				onDismiss={onClose}
				snapPoints={({ minHeight, maxHeight }) => {
					return [minHeight, maxHeight * 0.75];
				}}
        className='z-50'>
				<Delivery {...props} />
			</BottomSheet>		</>
	);
};

const PathnerOption = ({ selectedPathner = null, errors = null, touched = null, values = {}, isLoadingDeliveryList = false, setValues = () => {}, setIsShowDelivery = () => {}, setIsShowBottomSheet = () => {} }) => {
	return (
		<div className={`px-4 mt-4 border-b-8 border-solid pb-4 border-gray-100 ${values?.orderType !== 'delivery' ? 'hidden' : ''}`}>
			<div className='text-gray-900 text-xs font-semibold'>Opsi Pengiriman</div>
			<div className='mt-2'>
				<div className={`border-gray-300 border-1 border-solid rounded-md flex justify-between px-2 py-2.5`}>
					<div className='flex items-center'>
						<MotorbikeIcon className={`fill-[var(--rose-violet)]`} />
						<div className='pl-2 text-gray-900 text-sm font-semibold'>{selectedPathner?.name ? `${selectedPathner?.name} ${selectedPathner?.serviceType}` : 'Pilih Pengiriman'}</div>
					</div>
					<button
						id='summary_choose_delivery'
						className={`${
							errors?.deliveryType && touched?.deliveryType ? 'border-red-500 text-red-500' : isLoadingDeliveryList ? 'border-gray-300 text-[var(--rose-violet)]' : 'border-[var(--rose-violet)] text-[var(--rose-violet)]'
						} bg-white border-solid border-1 py-2 px-4 text-xs font-semibold rounded-md min-w-[80px] flex justify-center items-center`}
						disabled={isLoadingDeliveryList}
						onClick={() => {
							setIsShowDelivery(true);
							setIsShowBottomSheet(true);
						}}>
						{isLoadingDeliveryList ? <LoaderIcon /> : selectedPathner?.name ? 'Ubah' : 'Pilih'}
					</button>
				</div>
				{selectedPathner?.vehicle?.map((type, index) => {
					return (
						<div
							key={`type_${index}`}
							className={`border-1 border-gray-300 border-solid rounded-md flex justify-between px-2 py-2.5 mt-2 items-center ${type?.vehicleTypeCategory === values?.deliveryType?.vehicleTypeCategory ? '' : 'bg-gray-100'}`}
							onClick={() => {
								sendAnalyticsEvent('Select Delivery Type', 'summary_select_delivery_type', type?.vehicleTypeCategory);
								setValues((prev) => {
									return {
										...prev,
										deliveryType: type,
									};
								});
							}}>
							<div className=''>
								<div className={`text-sm capitalize ${type?.vehicleTypeCategory === values?.deliveryType?.vehicleTypeCategory ? 'text-gray-900' : 'text-gray-500'} font-semibold`}>{type?.vehicleTypeCategory}</div>
								<div className='text-xs text-gray-400 pt-1 font-thin'>Perkiraan tiba 20-30 menit</div>
							</div>
							<div className='flex'>
								<div className='text-gray-500 font-normal text-sm line-through hidden'>Rp6.000</div>
								<div className={`pl-2 ${type?.vehicleTypeCategory === values?.deliveryType?.vehicleTypeCategory ? 'text-gray-900' : 'text-gray-500'} font-semibold text-sm`}>
									{formatRupiah((type?.amount || 0) + values?.deliveryFee)}
								</div>
								<div className='pl-2'>
									<input
										id='transport'
										type='radio'
										name='transport'
										value='bike1'
										checked={type?.vehicleTypeCategory === values?.deliveryType?.vehicleTypeCategory}
										onChange={() => null}
										className={`${
											type?.vehicleTypeCategory === values?.deliveryType?.vehicleTypeCategory ? '!border-[var(--rose-violet)]' : '!border-gray-400 !bg-gray-200'
										} after:!bg-[var(--rose-violet)] active:bg-white focus:bg-transparent`}
									/>
								</div>
							</div>
						</div>
					);
				})}
			</div>
		</div>
	);
};

const PaymentOption = ({
	isLoadingPaymentMethodList = false,
	isLoadingUvBalance = false,
	isLoadingCheckPinUltraValue = false,
	isDisableUltraValue = false,
	isNeedVerifyPinUltraValue = false,
	values = {},
	UVBalance = {},
	setIsShowPaymentMethod = () => {},
	setIsShowBottomSheet = () => {},
}) => {
	const user = useSelector((store) => store?.user);
	const hideMethod =
		user?.is_b2b &&
		(
			user?.paymentMethod?.toLowerCase() === 'direct' 
			|| user?.companyName?.toLowerCase() === 'bri'
			|| user?.companyName?.toLowerCase() === 'mandiri'
		);
	return (
		<div className={`mx-4 mt-4 ${hideMethod ? 'hidden' : ''}`}>
			<div className='text-gray-900 text-sm font-semibold'>Metode Pembayaran</div>
			<div
				id='summary_view_payment_methods'
				className={`mt-2 border-solid border-1 border-gray-300 rounded-lg px-4 py-2 flex justify-between items-center min-h-14 ${isDisableUltraValue && 'opacity-50'}`}
				onClick={() => {
					if (isLoadingPaymentMethodList || isLoadingUvBalance || isLoadingCheckPinUltraValue) return;
					setIsShowPaymentMethod(true);
					setIsShowBottomSheet(true);
					sendAnalyticsCustomEvent('summary_topup_ultra_value');
					trackMetaPixelEvent('summary_topup_ultra_value');	
				}}>
				{isLoadingPaymentMethodList || isLoadingUvBalance || isLoadingCheckPinUltraValue ? (
					<div className='flex justify-center items-center w-full h-full'>
						<LoaderIcon />
					</div>
				) : (
					<>
						<div className='flex items-center'>
							{isNeedVerifyPinUltraValue ? <UltraVoucherIcon /> : <img alt={values?.paymentType?.alt ?? ''} src={values?.paymentType?.image_url} className={values?.paymentType?.image_size ?? 'w-9 h-auto'} />}
							<div className='pl-2'>
								<div className='text-gray-700 text-xs font-thin'>{values?.paymentType?.name ?? ''}</div>
								{isNeedVerifyPinUltraValue && <div className='text-gray-900 text-sm font-semibold'>{formatRupiah(UVBalance?.value ?? 0)}</div>}
								{isDisableUltraValue && <div className={`text-xs pt-1 font-thin text-red-700`}>Saldo Anda tidak mencukupi</div>}
							</div>
						</div>
						<ChevronRightIcon className='h-4 w-4 text-gray-800' strokeWidth={3} />
					</>
				)}
			</div>
		</div>
	);
};

const ProductOption = ({ cart = {}, handleGetProductDetail = () => {}, handleCart = () => {}, outlet = {}, user = {} }) => {
	const navigate = useNavigation();
	const { selectedOrderType, tableNumber } = useSelector((store) => store?.order);
	const orderType = cleanText(selectedOrderType?.av_name);

	return (
		<>
			<div className='mx-4 mt-4'>
				<div className='text-gray-900 text-sm font-semibold'>Ringkasan Pesanan</div>
				<div className='mt-4'>
					{cart?.item?.map((item, index) => {
						return <CartDetail key={index} data={item} index={index} handleGetProductDetail={handleGetProductDetail} handleCart={handleCart} />;
					})}
				</div>
			</div>
			<div className='border-b-1 border-solid pb-2 border-gray-200' />
			<div className='flex justify-between px-4 my-4 items-center border-b-1 border-solid pb-4 border-gray-200'>
				<div>
					<div className='text-sm text-gray-900 font-semibold'>Tambah Lagi?</div>
					<div className='text-xs text-gray-500 pt-1 font-thin'>Ingin menambahkan yang lain? Tambah menu lainnya</div>
				</div>
				<button
					id='summary_add_more_product'
					className='bg-white border-solid border-1 border-[var(--rose-violet)] py-1.5 px-6 text-xs font-semibold text-[var(--rose-violet)] rounded-md min-w-fit'
					onClick={() => navigate.push(`/outlet/${outlet?.storeSlug}/${orderType}`)}>
					Tambah
				</button>
			</div>
			{(orderType === "dinein" && user?.is_b2b) && (
				<TableNumber tableNumber={tableNumber?.table_number} />
			)}
		</>
	);
};

const PaymentSummaryOption = ({ paymentSummary = {}, tooltipOtherFee = {}, totalNominalB2BVoucher = 0, tooltipVoucherList = [], maxNominalVoucher = 0, totalPriceB2BVoucher = 0, strikeOutTotalPayment = 0, values = {} }) => {
	return (
		<div className='mx-4 mt-4 mb-28'>
			<div className='text-gray-900 text-sm font-semibold'>Rincian Pembayaran</div>
			<div className='mt-4 border-solid border-1 border-gray-300 rounded-lg px-4 py-2.5'>
				<div className={`flex justify-between items-center`}>
					<div className='text-gray-900 text-xs font-normal'>F&B Price</div>
					<div className='text-xs font-normal flex'>
						<div className='text-gray-700 pl-2'>{formatRupiah(paymentSummary?.subTotal || 0)}</div>
					</div>
				</div>
				<div className={`${!paymentSummary?.tax ? 'hidden' : 'flex'} justify-between items-center mt-1`}>
					<div className='text-gray-900 text-xs font-normal'>Tax</div>
					<div className='text-xs font-normal flex'>
						<div className='text-gray-700 pl-2'>{formatRupiah(paymentSummary?.tax)}</div>
					</div>
				</div>
				<div className={`${!paymentSummary?.pb1 ? 'hidden' : 'flex'} justify-between items-center mt-1`}>
					<div className='text-gray-900 text-xs font-normal'>PB1</div>
					<div className='text-xs font-normal flex'>
						<div className='text-gray-700 pl-2'>{formatRupiah(paymentSummary?.pb1)}</div>
					</div>
				</div>
				<div className={`${(!paymentSummary?.deliveryFee || values?.orderType !== 'delivery') ? 'hidden' : 'flex'} justify-between items-center mt-1`}>
					<div className='text-gray-900 text-xs font-normal'>Delivery</div>
					<div className='text-xs font-normal flex'>
						<div className='text-gray-400 font-thin line-through hidden'>Rp16.000</div>
						<div className='text-gray-700 pl-2'>{formatRupiah(paymentSummary?.deliveryFee || 0)}</div>
					</div>
				</div>
				<div className={`${!paymentSummary?.otherFee ? 'hidden' : 'flex'} justify-between items-center mt-1`}>
					<div className='text-gray-900 text-xs font-normal flex items-center'>
						Biaya lainnya
						<TooltipInfo title='Apa saja biaya di dalam nya?' items={tooltipOtherFee} id='summary_tooltip_other_fees' btn_id='summary_tooltip_other_fees_gotit' />
					</div>
					<div className='text-xs font-normal flex'>
						<div className='text-gray-700 pl-2'>{formatRupiah(paymentSummary?.otherFee || 0)}</div>
					</div>
				</div>
				<div className={`${!totalNominalB2BVoucher ? 'hidden' : 'flex'} justify-between items-center mt-1`}>
					<div className='text-gray-900 text-xs font-normal'>Beli Voucher</div>
					<div className='text-xs font-normal flex'>
						<div className='text-gray-400 font-thin line-through'>{formatRupiah(totalNominalB2BVoucher)}</div>
						<div className='text-gray-700 pl-2'>{formatRupiah(totalPriceB2BVoucher)}</div>
					</div>
				</div>
				<div className={`${!paymentSummary?.fixTotalVoucherNominal ? 'hidden' : 'flex'} justify-between items-center mt-2`}>
					<div className='text-gray-900 text-xs font-normal flex items-center'>
						<TicketDiscountIcon className='h-6 w-6 mr-1' />
						Voucher Terpakai
						<TooltipInfo title='Voucher Terpakai' items={tooltipVoucherList} id='summary_tooltip_voucher_applied' btn_id='summary_tooltip_voucher_applied_gotit' />
					</div>
					<div className='text-xs font-normal flex'>
						<div className='text-[var(--rose-violet)] pl-2'>-{formatRupiah(paymentSummary?.fixTotalVoucherNominal || 0)}</div>
					</div>
				</div>

        {paymentSummary?.strikeDiscount > 0 && (
          <div className="mt-2 border-b border-gray-200 pb-2">
            <div className="flex items-center gap-2 rounded-xl border border-green-200 bg-green-50 px-3 py-2">
              <div className="text-green-500 text-sm">
                🎉
              </div>

              <div className="text-green-600 text-xs font-normal">
                Kamu berhasil hemat{' '}
                <span className="font-semibold">
                  {formatRupiah(
                    paymentSummary?.strikeDiscount
                  )}
                </span>{' '}
                pada pesanan ini!
              </div>
            </div>
          </div>
        )}

				<div className='border-b-1 border-solid pb-2 border-gray-300' />
				<div className='flex justify-between items-center mt-2'>
					<div className='text-gray-900 text-sm font-extrabold items-center'>Total Pembayaran</div>
					<div className='text-sm font-extrabold flex'>
						<div className={`${(Number(paymentSummary?.totalPayment) >= Number(strikeOutTotalPayment)) && 'hidden'} text-gray-400 font-thin line-through`}>{formatRupiah(strikeOutTotalPayment)}</div>
						<div className='text-gray-900 pl-2'>{formatRupiah(paymentSummary?.totalPayment || 0)}</div>
					</div>
				</div>
			</div>
		</div>
	);
};

const NotesOption = ({ values = {}, setValues = () => {} }) => {
	return (
		<div className={`px-4 mt-4 border-b-8 border-solid pb-4 border-gray-100 ${values?.orderType !== "delivery" ? 'hidden' : ''}`}>
			<div className='flex items-center text-center'>
				<DoubleNoteIcon />
				<div className='text-xs text-gray-900 font-semibold pl-2'>Catatan Pengiriman</div>
				<div className='text-xs text-gray-400 font-thin pl-2'>Opsional</div>
			</div>
			<textarea
				id='summary_delivery_note'
				className='mt-2 py-2.5 px-4 text-xs placeholder:text-xs placeholder:text-gray-400 border-1 border-solid border-gray-300 bg-white h-auto'
				rows={1}
				defaultValue={values?.notes ?? ''}
				onChange={(e) => {
					setValues((prev) => {
						return {
							...prev,
							notes: e.target.value ?? '',
						};
					});
				}}
				placeholder='cth: Tolong letakkan makanan di depan pintu'
			/>
		</div>
	);
};

const Summary = () => {
	const dispatch = useDispatch();
	const navigate = useNavigation();

	const user = useSelector((store) => store?.user);
  	const device = useSelector((store) => store?.device);
  	const order = useSelector((store) => store?.order);

	const [outlet, setOutlet] = useState(null);
	const [product, setProduct] = useState(null);
	const [item, setItem] = useState(null);
	const [cartItem, setCartItem] = useState(null);
	const [UVBalance, setUVBalance] = useState(null);
	const [cart, setCart] = useState(null);
  const [totalOrder, setTotalOrder] = useState(null);

	const [pathnerList, setPathnerList] = useState([]);
	const [selectedPathner, setSelectedPathner] = useState(null);
	const [paymentMethodList, setPaymentMethodList] = useState([]);
	const [myVoucherList, setMyVoucherList] = useState([]);
	const [b2bVoucherList, setB2bVoucherList] = useState([]);
	const [voucherGlobalList, setVoucherGlobalList] = useState([]);

	const [isLoadingPaymentMethodList, setisLoadingPaymentMethodList] = useState(false);
	const [isLoadingDeliveryList, setisLoadingDeliveryList] = useState(false);
	const [isShowDelivery, setIsShowDelivery] = useState(false);
	const [isLoading, setIsLoading] = useState(false);
	const [isShowBottomSheet, setIsShowBottomSheet] = useState(false);
	const [isShowSimpleProduct, setIsShowSimpleProduct] = useState(false);
	const [isShowComboProduct, setIsShowComboProduct] = useState(false);
	const [isLoadingVoucherList, setisLoadingVoucherList] = useState(false);
	const [isShowVoucher, setIsShowVoucher] = useState(false);
	const [isShowMoreVoucher, setIsShowMoreVoucher] = useState(false);
	const [isShowPaymentMethod, setIsShowPaymentMethod] = useState(false);
	const [isLoadingUvBalance, setIsLoadingUvBalance] = useState(false);
	const [isShowDeliveryLocation, setIsShowDeliveryLocation] = useState(false);
	const [isTooFar, setIsTooFar] = useState(false);
	const [isShowSetupPin, setIsShowSetupPin] = useState(false);
	const [isLoadingCheckPinUltraValue, setIsLoadingCheckPinUltraValue] = useState(false);
	const [isUltraValueAvailable, setIsUltraValueAvailable] = useState(false);
	const [isShowVerifyPinUltraValue, setShowVerifyPinUltraValue] = useState(false);
	const [isInvalidPin, setIsInvalidPin] = useState(false);
	const [isShowTutor, setIsShowTutor] = useState(false);
	const [showClosed, setShowClosed] = useState(false);
  	const [errorOpen, setErrorOpen] = useState(false);
  	const [isOpenDelivery, setIsOpenDelivery] = useState(false);
	const [isShowConfirmation, setIsShowConfirmation] = useState(false);

	const [showVoucherDetail, setShowVoucherDetail] = useState({
		isOpen: false,
		data: null,
    type: null
	});

	const [defaultValues, setDefaultValues] = useState({
		unquieid: uniqueID,
		customerID: encodeValue(user?.customerID),
		paymentReference: null,
    orderType: null,
    availabilityID: null,
    availabilityName: null,
    orderSource: 'web',
    instantOrder: 'Yes',
    orderLocalNumber: null,
    additionalDeliveryCharge: 0,
    taxCharge: 0,
    taxAmount: 0,
    totalDiscount: 0,
    discountType: '',
		sender: {
			firstName: user?.firstName,
			email: user?.email ?? '',
			phone: user?.primary_phone,
		},
		deliveryType: null,
		deliveryFee: 0,
		deliverySubsidies: 0,
		notes: '',
		paymentType: null,
		origin: null,
		destinations: {
			address: user?.address,
			coordinate: {
				latitude: user?.latitude,
				longitude: user?.longitude,
			},
			village: user?.village,
			district: user?.district,
			city: user?.city,
			province: user?.state,
			postalCode: user?.postalCode ?? '',
			state: user?.state,
			country: user?.country,
			recipient: {
				firstName: user?.firstName,
				email: user?.email,
				phone: user?.primary_phone,
				lastName: user?.lastName || '',
				detail: user?.detail || '-',
			},
			items: [],
		},
		pin: null,
	});

	const isB2BMANDIRI = 
	  		user?.is_b2b === true && user?.companyName?.toLowerCase() === "mandiri";

	const [isShowWarningVoucher, setIsShowWarningVoucher] = useState(false);
	const [dataVoucherWarning, setDataVoucherWarning] = useState(null);
  const [isShowWarningRedeem, setIsShowWarningRedeem] = useState(false);
	const [dataVoucherRedeem, setDataVoucherRedeem] = useState(null);

	const orderSchema = Yup.object().shape({
		unquieid: Yup.string().required('Unique ID diperlukan'),
		customerID: Yup.string().required('Customer ID diperlukan'),
		orderType: Yup.string().required('Order Type diperlukan'),
    availabilityID: Yup.string().required('availabilityID diperlukan'),
    availabilityName: Yup.string().required('availabilityName diperlukan'),
    orderLocalNumber: Yup.string().required('orderLocalNumber diperlukan'),
    paymentReference: Yup.string().required('paymentReference diperlukan'),
		notes: Yup.string().optional(),

		sender: Yup.object().shape({
			firstName: Yup.string().required('Nama Depan diperlukan'),
			email: Yup.string().email('Invalid email format').required('Email is required'),
			phone: Yup.string().required('Nomor Telepon diperlukan'),
		}),

		deliveryType: Yup.mixed().when('orderType', {
			is: (orderType) => orderType ? orderType.includes('delivery') : true,
			then: (schema) =>
				schema
					.test('is-delivery-valid', 'Tipe Pengiriman tidak ditemukan', (delivery) => {
						if (typeof delivery === 'object') return true;
						return false;
					})
					.required('Pengiriman diperlukan'),
			otherwise: (schema) => schema.notRequired(),
		}),

		paymentType: Yup.mixed()
			.test('is-payment-type-valid', 'Tipe Pembayaran diperlukan', (payment) => {
				if (typeof payment === 'object' && payment?.code === 'ULTRA-VOUCHER') {
					return Number(UVBalance?.value || 0) >= Number(paymentSummary?.totalPayment || 0);
				}
				if (typeof payment === 'object') {
					return true;
				}
				return false;
			})
			.required('Tipe Pembayaran diperlukan'),

		origin: Yup.object().shape({
      storeID: Yup.string().required('Store ID diperlukan'),
			address: Yup.string().required('Alamat asal wajib ada.'),
			keywords: Yup.string().required('Keywords wajib ada.'),
			coordinate: Yup.object().shape({
				latitude: Yup.string().required('Latitude asal wajib ada.'),
				longitude: Yup.string().required('Longitude asal wajib ada.'),
			}),
			village: Yup.string().required('Desa/Keluharan asal wajib ada.'),
			district: Yup.string().required('Kecamatan asal wajib ada.'),
			city: Yup.string().required('Kota/Kabupaten asal wajib ada.'),
			province: Yup.string().required('Provinsi asal wajib ada.'),
			postalCode: Yup.string().required('Kode Pos asal wajib ada.'),
		}),

		destinations: Yup.object().when('orderType', {
			is: (orderType) => orderType ? orderType.includes('delivery') : true,
			then: (schema) =>
				schema.shape({
					address: Yup.string().required('Alamat tujuan wajib ada.'),
					coordinate: Yup.object().shape({
						latitude: Yup.string().required('Latitude tujuan wajib ada.'),
						longitude: Yup.string().required('Longitude tujuan wajib ada.'),
					}),
					village: Yup.string().required('Desa/Kelurahan tujuan wajib ada.'),
					district: Yup.string().required('Kecamatan tujuan wajib ada.'),
					city: Yup.string().required('Kota/Kabupaten tujuan wajib ada.'),
					province: Yup.string().required('Provinsi tujuan wajib ada.'),
					postalCode: Yup.string(),
					recipient: Yup.object().shape({
						firstName: Yup.string().required('Nama penerima wajib ada.'),
						email: Yup.string().email('Format email tidak valid.').required('Email penerima wajib ada.'),
						phone: Yup.string().required('Nomor telepon penerima wajib ada.'),
					}),
					items: Yup.array().min(1, 'Minimal satu item wajib ditambahkan.').required('Item wajib ditambahkan.'),
				}),
			otherwise: (schema) => schema.notRequired(),
		}),
	});

	const formik = useFormik({
		enableReinitialize: true,
		initialValues: defaultValues,
		validationSchema: orderSchema,
		onSubmit: async () => {
			return await handlePayment();
		},
	});

	const { errors, touched, submitForm, values, setValues, isSubmitting } = formik;

	const findFirstError = (errors) => {
		if (errors.destinations && errors.destinations.address) {
			return errors.destinations.address;
		}

		for (const key in errors) {
			if (typeof errors[key] === 'object' && errors[key] !== null) {
				const nestedError = findFirstError(errors[key]);
				if (nestedError) {
					return nestedError;
				}
			}
			if (typeof errors[key] === 'string') {
				return errors[key];
			}
		}
		return null;
	};

	useEffect(() => {
		sendAnalyticsPageView('summary_session');
	}, []);

	useEffect(() => {
		if (isShowPaymentMethod) {
			sendAnalyticsPageView('payment_methods_session');
		}
	}, [isShowPaymentMethod]);

	useEffect(() => {
		if (isShowVoucher) {
			sendAnalyticsPageView('voucher_session');
		}
	}, [isShowVoucher]);

	useEffect(() => {
		if (Object.keys(errors).length > 0 && Object.keys(touched).length > 0) {
			const firstError = findFirstError(errors);
			if (firstError) {
        showError({
          title: firstError,
        });
			}
		}
	}, [isSubmitting]);

	const handleGetStoreDetail = async () => {
		if (!cart?.store?.storeID || !user?.token) return;
		console.log('handleGetStoreDetail');
		try {
			let url = `store/storeDetails?unquieid=${uniqueID}&storeID=${cart?.store?.storeID}`;

			if (user?.latitude && user?.longitude) {
				url += `&latitude=${user?.latitude}&longitude=${user?.longitude}`;
			}
			const res = await axiosInstance.get(url, {
				headers: {
					Accept: 'application/json, text/plain, */*',
          ...authHeaders().headers
				},
			});
			if (res.data?.status === 'ok') {
				const data = res.data?.result;
				setOutlet(data || null);
			}
		} catch (error) {
			console.log('error: ', error);
		}
	};

	const handleCart = async (data) => {
		console.log('handleCart');
		try {
			setIsLoading(true);
			let postData = {
				unquieid: uniqueID,
				availabilityID: deliveryId,
				availabilityName: 'Delivery',
				shopID: encodeValue(outlet?.storeID),
			};
			if (data?.productType === 'Simple') {
				postData = {
					...postData,
					...data,
				};
			} else {
				postData = {
					...postData,
					...data,
					// productTotalPrice: data?.totalPrice,
					// productPrice: data?.price,
					comboset: JSON.stringify(data?.comboset),
				};
			}

			const url = `cart/${data?.type === 'add' ? 'createCart' : 'updateCartItem'}`;
			const res = await axiosInstance.post(url, qs.stringify(postData), authHeaders());
			if (res?.data?.status === 'ok') {
				setCartItem(null);
				setProduct(null);
				setItem(null);
				handleCloseBottomSheet();
				await handleGetCart();
			}
			setIsLoading(false);
		} catch (error) {
			console.log('error: ', error);
			setIsLoading(false);
		}
	};

  const handleGetTotalOrder = async () => {
    try {
      setIsLoading(true);
      const formData = new URLSearchParams();
      formData.append("unquieid", uniqueID);

			const url = `orders/total-order`;
			const res = await axiosInstance.post(url, formData, {
				headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          ...authHeaders().headers
				},
			});

			if (res?.status === 200) {
				setTotalOrder(Number(res?.data?.result) || 0);
			}
    } catch (error) {
      console.log('error: ', error);
      setIsLoading(false);

    }
  }

	const handleGetCart = async () => {
		if (!user?.token) return;
		console.log('handleGetCart');
		try {
			setIsLoading(true);
			const url = `cart/loadCartDetails?unquieid=${uniqueID}&availabilityID=${deliveryId}`;
			const res = await axiosInstance.get(url, {
				headers: {
					Accept: 'application/json, text/plain, */*',
          ...authHeaders().headers
				},
			});
			if (res?.data?.status === 'ok') {
				setCart(res?.data?.result || null);
			}
			if (res?.data?.message === 'There are no items in your cart') {
				isEmptyData(outlet?.storeSlug) ? navigate.back() : navigate.push(`/outlet/${outlet?.storeSlug}/delivery`);
			}
			setIsLoading(false);
		} catch (error) {
			console.log('error: ', error);
			setIsLoading(false);
		}
	};

	const axiosRetry = async (url, data, config, maxRetries = 3, delayMs = 500) => {
		let attempts = 0;
		console.log('axiosRetry: ', attempts);
		const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

		while (attempts < maxRetries) {
			try {
				const res = await axiosInstance.post(url, JSON.stringify(data), config);
				console.log(`Attempt ${attempts + 1}: Status ${res?.status}`);

				if (res?.data?.status === 'ok') {
					return res;
				} else {
					console.log(`Attempt ${attempts + 1}`);
				}
			} catch (error) {
				console.log(`Attempt ${attempts + 1}: Error`, error);
			}

			attempts += 1;
			if (attempts < maxRetries) {
				console.log(`Retrying in ${delayMs}ms... (${attempts}/${maxRetries})`);
				await delay(delayMs);
			}
		}

		return null;
	};

	const handleSetSelectedUfoodPathner = (serviceList = []) => {
		if (!serviceList?.length) return null;
		console.log('handleSetSelectedUfoodPathner');
		const ufood = serviceList?.find((service) => service?.name === 'UFood');
		if (Boolean(ufood ?? null)) {
			setSelectedPathner(ufood ?? null);
			if (!ufood?.vehicle?.length) return;
			return ufood?.vehicle?.[0] ?? null;
		}
		return null;
	};

	const handleGetPathnerList = async () => {
		if (!user?.token || !cart?.store?.storeAddress || !user?.address || isLoadingDeliveryList || values?.orderType != 'delivery') return;
		console.log('handleGetPathnerList');
		try {
			setisLoadingDeliveryList(true);

			const config = {
				headers: {
					'Content-Type': 'application/json',
          ...authHeaders().headers
				},
			};

			const dataPost = {
				unquieid: uniqueID,
				sender: {
					firstName: user?.firstName,
					email: user?.email,
					phone: user?.primary_phone,
				},
				origin: {
					address: cart?.store?.storeAddress,
					coordinate: cart?.store?.coordinate,
					village: cart?.store?.village,
					district: cart?.store?.district,
					city: cart?.store?.city,
					province: cart?.store?.province,
					postalCode: cart?.store?.postalCode ?? '',
					keywords: cart?.store?.storeName,
				},
				destinations: {
					address: user?.address,
					coordinate: {
						latitude: user?.latitude,
						longitude: user?.longitude,
					},
					village: user?.village,
					district: user?.district,
					city: user?.city,
					province: user?.state,
					postalCode: user?.postalCode ?? '',
					state: user?.state,
					country: user?.country,
					recipient: {
						firstName: user?.firstName,
						email: user?.email,
						phone: user?.primary_phone,
						lastName: user?.lastName,
					},
					items: (cart?.item || [])?.map((product, index) => {
						return {
							itemName: product?.itemName,
							itemQuantity: product?.itemQuantity,
							itemRemarks: product?.itemNotes ?? '',
						};
					}),
				},
        store_id: cart?.store?.storeID
			};

			const url = `deliverypartners/loadPartnersList`;
			const res = await axiosRetry(url, dataPost, config, 3, 1500);

			if (res?.data?.status === 'ok' && res?.data?.result?.length) {
				const { delivery_fee, delivery_subsidies } = res?.data || {};
				const result = res?.data?.result || [];
				const normalizedVehicleData = result?.map((item) => {
					item.vehicle = item.vehicle.map((vehicle) => {
						// if (vehicle.vehicleType === "MOTORCYCLE") {
						//   vehicle.vehicleType = "bike";
						// }
						// if (vehicle.vehicleType === "TRUCK175") {
						//   vehicle.vehicleType = "Truck";
						// }
						return vehicle;
					});
					return item;
				});
				const serviceList = normalizedVehicleData
					?.map((item) => item.vehicle)
					.flat()
					.reduce((acc, vehicle) => {
						const existingService = acc.find((service) => service.name === vehicle.name && service.serviceType === vehicle.serviceType);

						if (existingService) {
							existingService.vehicle.push(vehicle);
						} else {
							acc.push({
								name: vehicle.name,
								serviceType: vehicle.serviceType,
								vehicle: [vehicle],
							});
						}

						return acc;
					}, [])
					.sort((a, b) => {
						if (a.name === 'UFood') return -1;
						if (b.name === 'UFood') return 1;
						return 0;
					});
				setPathnerList(serviceList);
				const bike = handleSetSelectedUfoodPathner(serviceList);
				setDefaultValues((prev) => {
					return {
						...prev,
						deliveryFee: Number(delivery_fee) || 0,
						deliverySubsidies: Number(delivery_subsidies) || 0,
						deliveryType: bike,
					};
				});
				handleCloseBottomSheet();
			} else {
				handleCloseBottomSheet();
				setPathnerList([]);
				setSelectedPathner(null);
				setIsShowBottomSheet(true);
				setIsTooFar(true);
			}
			setisLoadingDeliveryList(false);
		} catch (error) {
			console.log('error: ', error);
			setisLoadingDeliveryList(false);
		}
	};

	const handleGetPaymentReference = async (needReturn = false) => {
		if (!user?.token) return;
		try {
			console.log('handleGetPaymentReference');
			setIsLoading(true);
			const postData = {
				unquieid: uniqueID,
			};

			const url = `Paymentuvcr/generatePaymentRefrence`;

			const res = await axiosInstance.post(url, qs.stringify(postData), authHeaders());
			if (res?.data?.status === 'ok') {
				const reference = res?.data?.paymentRefrence || '';
				const orderNumber = res?.data?.order_local_no || '';
				if (!needReturn) {
					setDefaultValues((prev) => {
						return {
							...prev,
							paymentReference: reference,
							orderLocalNumber: orderNumber,
						};
					});
				} else {
					return {
						paymentReference: reference,
						orderLocalNumber: orderNumber,
					};
				}
			}
			setIsLoading(false);
		} catch (error) {
			console.log('error: ', error);
			setIsLoading(false);
		}
	};

	const refreshToken = async () => {
		if (!user?.customerID || !user?.refresh_token) return;
		console.log('refreshToken');
		try {
			const response = await axiosInstance.post(`auth/refresh-token`, {
				refresh_token: user?.refresh_token,
				customer_id: user?.customerID,
			});

			if (response?.status === 200 && response?.data?.status === 'ok') {
				const data = response?.data?.data;
				dispatch(
					setUser({
						token: data?.token,
					}),
				);
			} else {
        showError({
          title: "please relogin",
        });
			}
		} catch (error) {
			console.log('error: ', error);
		}
	};

	useEffect(() => {
		dispatch(clearPayment());
	}, []);

	// useEffect(() => {
	// 	if (!user?.is_b2b) {
	// 		refreshToken();
	// 	}
	// }, [user?.customerID, user?.refresh_token]);

	useEffect(() => {
		if (!user?.is_b2b && user?.paymentMethod === 'pina' && !isB2BMANDIRI) {
			handleGetUVBalance();
			handleCheckPinUltraValue();
		}
	}, [user?.token, user?.refresh_token]);

	useEffect(() => {
    handleGetTotalOrder();
		handleGetCart();
	}, [user?.token]);

	useEffect(() => {
    if (isEmptyData(defaultValues?.paymentReference)) {
      handleGetPaymentReference(); 
    }
	}, [user?.token, defaultValues?.paymentReference]);

	useEffect(() => {
		if (!cart?.store?.storeAddress || !user?.address) return;
		setDefaultValues((prev) => {
			return {
				...prev,
				origin: {
          outletBrandID: cart?.store?.outletBrandID,
          storeID: cart?.store?.storeID,
          name: cart?.store?.storeName || '',
					address: cart?.store?.storeAddress || '',
          open: cart?.store?.storeOpen || '',
          openTime: cart?.store?.outletOpenTime || '',
          closeTime: cart?.store?.outletCloseTime || '',
          unit: cart?.store?.unit || '',
          floor: cart?.store?.floor || '',
					coordinate: cart?.store?.coordinate || {},
					village: cart?.store?.village || '',
					district: cart?.store?.district || '',
					city: cart?.store?.city || '',
					province: cart?.store?.province || '',
					postalCode: cart?.store?.postalCode || '',
					keywords: cart?.store?.storeName || '',
				},
        sender: {
          firstName: user?.firstName,
          email: user?.email,
          phone: user?.primary_phone,
        },
				destinations: {
					address: user?.address,
					coordinate: {
						latitude: user?.latitude,
						longitude: user?.longitude,
					},
					village: user?.village,
					district: user?.district,
					city: user?.city,
					province: user?.state,
					postalCode: user?.postalCode || '',
					state: user?.state,
					country: user?.country,
					recipient: {
						firstName: user?.firstName,
						email: user?.email,
						phone: user?.primary_phone,
						lastName: user?.lastName || '',
            detail: user?.detail || '-',
					},
					items: cart?.item || [],
				},
			};
		});
	}, [cart?.store?.storeAddress, user?.address]);

	useEffect(() => {
		handleGetStoreDetail();
	}, [cart?.store?.posID]);

	useEffect(() => {
    if (!user?.is_b2b) {
			handleGetMyVoucherList();      
    }
	}, [cart?.store?.posID]);

	useEffect(() => {
			handleGetB2BVoucherList();
	}, [cart?.store?.posID]);

  useEffect(() => {
    handleGetVoucherGlobalList();
	}, [cart?.subTotal, totalOrder]);

  useEffect(() => {
    if (isEmptyData(values?.deliveryType)) return;
    autoApplyVoucherGlobalForDelivery(voucherGlobalList)
  }, [values?.deliveryType, values?.orderType]) 

	useEffect(() => {
		handleGetPathnerList();
	}, [user?.token, cart?.store?.storeAddress, user?.address, values?.orderType, order?.selectedOrderType]);

	const handleGetProductDetail = async (slug, data) => {
		console.log('handleGetProductDetail');
		try {
			setIsLoading(true);
			const url = `catalogs/productdetails?unquieid=${uniqueID}&productID=${slug}`;
			const res = await axiosInstance.get(url, {
				headers: {
					Accept: 'application/json, text/plain, */*',
          ...authHeaders().headers
				},
			});
			if (res.data?.status === 'ok') {
				const product = res.data?.result || null;
				setCartItem(product);
				setProduct(product);
				setItem(data);
				setIsShowBottomSheet(true);
				if (product?.product_type === '1') {
					setIsShowSimpleProduct(true);
				}
				if (product?.product_type === '2') {
					setIsShowComboProduct(true);
				}
			}
			if (res?.data?.status === 'error') {
        showError({
          title: "Product not found",
        });
			}
			setIsLoading(false);
		} catch (error) {
			console.log('error: ', error);
			setIsLoading(false);
		}
	};

	const handleFavorite = async () => {
		console.log('handleFavorite');
		try {
			const dataPost = {
				unquieid: uniqueID,
				shopID: encodeValue(cart?.store?.storeID),
			};
			const url = `store/${Boolean(Number(outlet?.favorite || outlet?.favourite)) ? 'removeFavourite' : 'addFavourite'}`;
			const res = await axiosInstance.post(url, qs.stringify(dataPost), authHeaders());
			if (res?.data?.status === 'ok') {
				handleGetStoreDetail();
			}
		} catch (error) {
			console.log('error: ', error);
		}
	};

	const groupByNominal = async (b2bVoucherList = []) => {
		console.log('groupByNominal');
		const result = [];

		b2bVoucherList?.forEach((voucher) => {
			const existingVoucher = result.find((v) => v.nominal === voucher.nominal);

			if (existingVoucher) {
				existingVoucher.total_is_use += voucher.is_use ? 1 : 0;
				existingVoucher.total_stock_available += voucher.stock_available;
			} else {
				result.push({
					...voucher,
					total_is_use: voucher.is_use ? 1 : 0,
					total_stock_available: voucher.stock_available,
				});
			}
		});

		return result;
	};

  const validationVoucherGlobalForProduct = async (voucher = {}) => {
    console.log('validationVoucherGlobalForProduct');
    let nominal_voucher = 0;
    let applied_products = [];

    if (Number(cart?.subTotal) < voucher?.min_transaction) {
      return {
        is_use: nominal_voucher > 0,
        nominal_voucher: nominal_voucher,
        applied_products: [],
        disabled: true,
      }
    };

    const matchCompany  = checkScope(voucher?.company_scope_ids, user?.companyID);
    const matchBrand    = checkScope(voucher?.brand_scope_ids, cart?.store?.outletBrandID);
    const matchOutlet   = checkScope(voucher?.outlet_scope_ids, cart?.store?.storeID);
    const matchUser  = checkScope(voucher?.user_scope_ids, user?.customerID);

    if (!matchCompany || !matchBrand || !matchOutlet || !matchUser) {
      return {
        is_use: nominal_voucher > 0,
        nominal_voucher: nominal_voucher,
        applied_products: [],
        disabled: true,
      }
    };

    if (matchCompany || matchBrand || matchOutlet || matchUser) {
      const price = Number(cart?.subTotal);
  
      if (voucher.type === "nominal") {
        nominal_voucher = voucher.value;
      }
  
      if (voucher.type === "percentage") {
        nominal_voucher = (price * voucher.value) / 100;
      }

    };

    if (!isEmptyData(voucher?.categories_scope_ids) || !isEmptyData(voucher?.product_scope_ids)) {
      
      nominal_voucher = 0;
      applied_products = [];

      for (const i of cart?.item || []) {

        const matchCategory = checkScope(voucher?.categories_scope_ids, i?.product_category_id);
        const matchProduct  = checkScope(voucher?.product_scope_ids, i?.product_primary_id);
  
        if (!matchCategory || !matchProduct) {
          continue;
        }
        
        let discount = 0;

        if (matchCategory && isEmptyData(voucher?.product_scope_ids)) {  
          let productPrice = Number(i?.itemUnitPrice);
          if (!isEmptyData(i?.comboset)) {
            i?.comboset?.forEach((c) => {
              c?.productDetails?.forEach((p) => {
                productPrice += Number(p?.productPrice || 0)
              })
            })
          }
  
          if (voucher?.type === "nominal") {
            discount = voucher.value;
          }
  
          if (voucher?.type === "percentage") {
            discount = (Number(productPrice) * voucher.value) / 100;
            if (discount > voucher?.max_discount) {
              discount = voucher?.max_discount;
            }
          }
  
          applied_products.push({
            itemID: i.itemID,
            itemName: i.itemName,
            company_id: user?.companyID,
            brand_id: cart?.store?.outletBrandID,
            category_id: i.product_category_id,
            product_id: i.product_primary_id,
            user_id: user?.customerID,
            quantity: Number(i.itemQuantity),
            unitPrice: Number(i.itemUnitPrice),
            totalPrice: Number(i.itemTotalPrice),
            discount: discount,
          });
        }
  
        if (matchProduct && !isEmptyData(voucher?.product_scope_ids)) {  

          discount = 0;
          applied_products = []
  
          let productPrice = Number(i?.itemUnitPrice);
          if (!isEmptyData(i?.comboset)) {
            i?.comboset?.forEach((c) => {
              c?.productDetails?.forEach((p) => {
                productPrice += Number(p?.productPrice || 0)
              })
            })
          }

		      productPrice = productPrice * i?.itemQuantity
  
          if (voucher?.type === "nominal") {
            discount = voucher.value;
          }
  
          if (voucher?.type === "percentage") {
            discount = (Number(productPrice) * voucher.value) / 100;
            if (discount > voucher?.max_discount) {
              discount = voucher?.max_discount;
            }
          }
  
          applied_products.push({
            itemID: i.itemID,
            itemName: i?.itemName,
            company_id: user?.companyID,
            brand_id: cart?.store?.outletBrandID,
            category_id: i?.product_category_id,
            product_id: i?.product_primary_id,
            user_id: user?.customerID,
            quantity: Number(i?.itemQuantity),
            unitPrice: Number(i?.itemUnitPrice),
            totalPrice: Number(i?.itemTotalPrice),
            discount: discount,
          });
        }
  
        nominal_voucher += discount;
  
      }
    } else {
      nominal_voucher = 0;
      applied_products = [];
      for (const i of cart?.item || []) {
        let discount = 0;

        let productPrice = Number(i?.itemTotalPrice);

        if (voucher?.type === "nominal") {
          discount = productPrice;
        }

        applied_products.push({
          itemID: i.itemID,
          itemName: i?.itemName,
          company_id: user?.companyID,
          brand_id: cart?.store?.outletBrandID,
          category_id: i?.product_category_id,
          product_id: i?.product_primary_id,
          user_id: user?.customerID,
          quantity: Number(i?.itemQuantity),
          unitPrice: Number(i?.itemUnitPrice),
          totalPrice: Number(i?.itemTotalPrice),
          discount: discount,
        });
        nominal_voucher += discount;
      }

      if (voucher?.type === "percentage") {
        const discountPercentage = (Number(cart?.subTotal) * voucher.value) / 100;
        if (discountPercentage > voucher?.max_discount) {
          nominal_voucher = voucher?.max_discount;
        } else {
          nominal_voucher = discountPercentage;
        }
      }
    }

    nominal_voucher = Math.round(Math.min(nominal_voucher, voucher?.type === "nominal" ? voucher?.value : voucher.max_discount ?? nominal_voucher));

    return {
      is_use: nominal_voucher > 0,
      nominal_voucher: nominal_voucher,
      applied_products,
      disabled: nominal_voucher <= 0,
    }

  }

  const validationVoucherGlobalForDelivery = async (voucher = {}) => {
    console.log('validationVoucherGlobalForDelivery');
    let nominal_voucher = 0;
    const price = Number(values?.deliveryType?.amount ?? 0);
    const voucherValue = Number(voucher?.value ?? 0);
    const maxDiscount = Number(voucher?.max_discount ?? 0);
	  if (price === 0) return;
    
    if ((Number(cart?.subTotal) < voucher?.min_transaction) || values?.orderType?.toUpperCase() !== VOUCHER_GLOBAL_PURPOSE.DELIVERY) {
      return {
        is_use: nominal_voucher > 0,
        nominal_voucher: nominal_voucher,
        disabled: true,
      }
    };

    const matchCompany  = checkScope(voucher?.company_scope_ids, user?.companyID);
    const matchBrand    = checkScope(voucher?.brand_scope_ids, cart?.store?.outletBrandID);
    const matchOutlet   = checkScope(voucher?.outlet_scope_ids, cart?.store?.storeID);
    const matchUser  = checkScope(voucher?.user_scope_ids, user?.customerID);

    if (!matchCompany || !matchBrand || !matchOutlet || !matchUser) {
      return {
        is_use: nominal_voucher > 0,
        nominal_voucher: nominal_voucher,
        disabled: true,
      }
    }

    if (matchCompany || matchBrand || matchOutlet || matchUser) {  
			if (voucher?.type === "nominal") {
				if (price < voucher.value) {
					nominal_voucher = price;	
				} else {
					nominal_voucher = voucher.value;
				}
			}
  
      if (voucher.type === "percentage") {
        nominal_voucher = (price * voucher.value) / 100;
      }

      nominal_voucher = Math.round(
        Math.min(
          nominal_voucher,
          voucher?.type === "nominal"
            ? voucher?.value
            : (voucher.max_discount ?? nominal_voucher)
        )
      );
    }

    if (!isEmptyData(voucher?.categories_scope_ids) || !isEmptyData(voucher?.product_scope_ids)) {
      let hasMatch = false;

      for (const item of cart?.item || []) {
        const matchCategory = checkScope(voucher.categories_scope_ids, item.product_category_id);
        const matchProduct = checkScope(voucher.product_scope_ids, item.product_primary_id);

        if (matchCategory || matchProduct) {
          hasMatch = true;
          break;
        }
      }

      if (!hasMatch) {
        return {
          is_use: nominal_voucher > 0,
          nominal_voucher,
          disabled: true,
        };
      }
	  }

    if (!isEmptyData(voucher?.delivery_scope_ids)) {
      const selectedDeliery = isEmptyData(values?.deliveryType) ? null : `${values?.deliveryType?.deliveryPartnerId}|${values?.deliveryType?.name}|${values?.deliveryType?.serviceType}|${values?.deliveryType?.vehicleType}`;
      const matchDelivery = checkScope(voucher?.delivery_scope_ids, selectedDeliery)

      if (!matchDelivery && !isEmptyData(selectedDeliery)) {
        return {
          is_use: nominal_voucher > 0,
          nominal_voucher: nominal_voucher,
          disabled: true,
        }
      }

			if (voucher?.type === "percentage") {
        const discountPercentage = (Number(price) * voucher.value) / 100;
        if (discountPercentage > voucher?.max_discount) {
          nominal_voucher = voucher?.max_discount;
        } else {
          nominal_voucher = discountPercentage;
        }
      }

			if (voucher?.type === "nominal") {
				if (price < voucher.value) {
					nominal_voucher = price;	
				} else {
					nominal_voucher = voucher.value;
				}
			}

      nominal_voucher = Math.round(nominal_voucher);
      
      return {
        is_use: nominal_voucher > 0,
        nominal_voucher: nominal_voucher,
        disabled: false,
      }
    }
    
    return {
      is_use: nominal_voucher > 0,
      nominal_voucher: nominal_voucher,
      disabled: false,
    }
  }

  const applyBestVoucher = (vouchers = [], type = VOUCHER_GLOBAL_PURPOSE.PRODUCT) => {
    if (!vouchers.length) return [];

    const filteredVouchers = vouchers.filter(
      v => v?.purpose?.toUpperCase() === type?.toUpperCase()
    );

    // cari nominal_voucher terbesar
    const maxVoucher = Math.max(
      ...filteredVouchers.map(v => v.nominal_voucher || 0)
    );

    // cari index voucher pertama yang punya nominal terbesar
    const bestIndex = vouchers.findIndex((v) => v?.purpose?.toUpperCase() === type?.toUpperCase() && v.nominal_voucher === maxVoucher && maxVoucher > 0);

    let picked = false;
  
    const bestVouchers = vouchers.map((voucher, index) => {
      const samePurpose = voucher?.purpose?.toUpperCase() === type?.toUpperCase();
      if (!samePurpose) {
        return voucher;
      }

      if (index === bestIndex && !picked) {
        // hanya 1 voucher terbaik yang aktif
        picked = true;
        return {
          ...voucher,
          is_use: true,
          disabled: false,
        };
      }
  
      // voucher lain → disable
      return {
        ...voucher,
        is_use: false,
        nominal_voucher: 0,
        applied_products: [],
        disabled: true,
      };
    });
    return bestVouchers;
  };

  const autoApplyVoucherGlobalForProduct = async (voucher = []) => {
		if (!voucher?.length) return [];
		console.log('autoApplyVoucherGlobalForProduct');

		const vouchersList = [];
		for (let vg of voucher || []) {
			let validation = {
        is_use: false,
        nominal_voucher: 0,
        disabled: false,
      }
			if (!vg?.referral && vg?.purpose?.toUpperCase() === VOUCHER_GLOBAL_PURPOSE.PRODUCT) {
				validation = await validationVoucherGlobalForProduct(vg);
     	}
			vouchersList?.push({ ...vg, ...validation });
		}

		const sorted = sortVouchers(vouchersList);
    const best = applyBestVoucher(sorted, VOUCHER_GLOBAL_PURPOSE.PRODUCT);
    return best;
	};

  const autoApplyVoucherGlobalForDelivery = async (voucher = []) => {
    if (!voucher?.length) return [];
    console.log('autoApplyVoucherGlobalForDelivery');
		const vouchersList = [];
		for (let vg of voucher || []) {
			let validation = {}
			if (!vg?.referral && vg?.purpose?.toUpperCase() === VOUCHER_GLOBAL_PURPOSE.DELIVERY) {
				validation = await validationVoucherGlobalForDelivery(vg);
     	}
			vouchersList?.push({ ...vg, ...validation });
		}

    const sorted = sortVouchers(vouchersList);
    const best = applyBestVoucher(sorted, VOUCHER_GLOBAL_PURPOSE.DELIVERY);
    setVoucherGlobalList(best)  
  }

	const autoApplyMyVoucher = async (voucherMy = []) => {
		if (!voucherMy?.length) return [];
		console.log('autoApplyMyVoucher');

		const myVouchersList = [];

		let totalMyNominal = 0;

		const cartSubTotal = Number(cart?.subTotal) || 0;

		for (let my of voucherMy || []) {
			let isUse = my?.is_use ?? false;
			if (totalMyNominal + my?.nominal_voucher <= cartSubTotal) {
				totalMyNominal += my?.nominal_voucher;
				isUse = true;
			}
			myVouchersList?.push({ ...my, is_use: isUse });
		}

		return myVouchersList;
	};

	const updateAutoApplyMyVoucher = async (voucherMy = []) => {
		if (!voucherMy?.length) return [];
		console.log('updateAutoApplyMyVoucher');

		const myVouchersList = [];

		let totalMyNominal = 0;

		const cartSubTotal = Number(cart?.subTotal) || 0;

		for (let my of voucherMy || []) {
			let isUse = my?.is_use ?? false;
			if (totalMyNominal + my?.nominal_voucher <= cartSubTotal) {
				totalMyNominal += my?.nominal_voucher;
				isUse = true;
			} else {
				isUse = false;
			}
			myVouchersList?.push({ ...my, is_use: isUse });
		}
		setMyVoucherList(myVouchersList);
	};

	const updateAutoApplyB2bVoucher = async (voucherB2b = []) => {
		if (!voucherB2b?.length) return [];
		console.log('updateAutoApplyB2bVoucher');

		const b2bVouchersList = [];

		for (let b2b of b2bVoucherList) {
			let totalIsUse = 0;
			b2bVouchersList.push({ ...b2b, total_is_use: totalIsUse });
		}
		setB2bVoucherList(b2bVouchersList);
	};

	useMemo(() => {
		if (isLoadingVoucherList || !cart?.subTotal) return;
		user?.paymentMethod === "pina" && updateAutoApplyMyVoucher(myVoucherList);
		updateAutoApplyB2bVoucher(b2bVoucherList);
	}, [cart?.subTotal]);

	const handleApplyB2BVoucher = () => {
		console.log('handleApplyB2BVoucher');

		const b2bList = [];

		let remainingNominal = Math.max(0, Number(cart?.subTotal) - paymentSummary?.fixTotalVoucherNominal);

		for (let b2b of b2bVoucherList) {
			let totalIsUse = 0;
			const availableStock = b2b?.total_stock_available || b2b?.stock_available || 0;
			const maxNominalUsage = Math.floor(remainingNominal / b2b.nominal);

      totalIsUse = Math.min(
        availableStock,
        maxNominalUsage,
        b2b?.max_qty ?? Number.MAX_SAFE_INTEGER
      );

			if (totalIsUse > 0) {
				remainingNominal -= totalIsUse * b2b.nominal;
			}

			b2bList.push({ ...b2b, total_is_use: totalIsUse });
		}
		setB2bVoucherList(b2bList);
	};

  const handleGetVoucherGlobalList = async () => {
		if (!cart?.store?.posID || !user?.token || !user?.refresh_token) return;
		console.log('handleGetVoucherGlobalList');
		try {
			setisLoadingVoucherList(true);

      const postDataVg = {
        brand_id: cart?.store?.outletBrandID || null,
        outlet_id: cart?.store?.storeID || null,
        category_id: [],
        product_id: [],
        total_order: totalOrder,
        birthday_date: null,
        total_transaction: null,
        page: 1,
        limit: 100
      };
      const vgUrl = 'voucher-global/list';
      const resVg = await axiosInstance.post(vgUrl, postDataVg, {
        headers: {
          'Content-Type': 'application/json',
          ...authHeaders().headers
        },
        timeout: 10 * 1000,
      });
      if (resVg?.data?.status === 'ok') {
        const voucher = await autoApplyVoucherGlobalForProduct(resVg?.data?.data?.data || []);
        setVoucherGlobalList(voucher);
      }

			setisLoadingVoucherList(false);
		} catch (error) {
			console.log('error: ', error);
			setisLoadingVoucherList(false);
		}
	};

	const handleGetMyVoucherList = async () => {
		if (!cart?.store?.posID || !user?.token || !user?.refresh_token) return;
		console.log('handleGetMyVoucherList');
		try {
			setisLoadingVoucherList(true);

			let voucherMyGrouping = [];
			let totalMyVoucher = 0;
			let voucherMy = [];

      const postDataMy = {
				posID: cart?.store?.posID ?? '',
				token: user?.token,
				refresh_token: user?.refresh_token,
			};
			const myUrl = `voucher/list`;
			let resMyLimit = null;
      if (user?.paymentMethod === "pina") {
        resMyLimit = await axiosInstance.post(myUrl, qs.stringify(postDataMy), { timeout: 10 * 1000, ...authHeaders() }); 
      }
			if (resMyLimit?.data?.status === 'ok') {
				voucherMyGrouping = resMyLimit?.data?.data || [];
				voucherMyGrouping?.forEach((voucher) => {
					totalMyVoucher += Number(voucher?.total_voucher) || 0;
				});
			}

			if (totalMyVoucher > 0) {
				postDataMy.page = 1;
				postDataMy.limit = totalMyVoucher;
				const resMy = await axiosInstance.post(myUrl, qs.stringify(postDataMy), { timeout: 10 * 1000, ...authHeaders() });
				if (resMy?.data?.status === 'ok') {
					voucherMy = resMy?.data?.data || [];
					if (voucherMy.length > 0) {
						const sortedMyVouchers = voucherMy?.sort((a, b) => new Date(a.expired_date) - new Date(b.expired_date));
						const autoApplyMy = await autoApplyMyVoucher(sortedMyVouchers);
						setMyVoucherList(autoApplyMy); 
					}
				}
			}
			setisLoadingVoucherList(false);
		} catch (error) {
			console.log('error: ', error);
			setisLoadingVoucherList(false);
		}
	};

  const handleGetB2BVoucherList = async () => {
		if (!cart?.store?.posID || !user?.token || !user?.refresh_token) return;
		console.log('handleGetB2BVoucherList');
		try {
			setisLoadingVoucherList(true);

			let voucherB2B = [];

			const postDataB2B = {
				merchantCode: cart?.store?.merchantCode ?? '',
				page: 1,
				limit: 10,
			};
			const b2bUrl = `voucher-b2b/list`;
			const resB2B = await axiosInstance.post(b2bUrl, qs.stringify(postDataB2B), { timeout: 10 * 1000, ...authHeaders() });
			if (resB2B?.data?.status === 'ok') {
				voucherB2B = resB2B?.data?.data || [];
			}

			const groupB2BVoucher = await groupByNominal(voucherB2B);
			const sortedB2BVouchers = groupB2BVoucher?.sort((a, b) => a.nominal - b.nominal);
			setB2bVoucherList(sortedB2BVouchers);

			setisLoadingVoucherList(false);
		} catch (error) {
			console.log('error: ', error);
			setisLoadingVoucherList(false);
		}
	};

	const handleUpdateVoucherList = async (id, voucher_type, use = false, type = 'plus', purpose = null) => {
		console.log('handleUpdateVoucherList');
		const updateMyVoucher = (voucherArray) => {
			console.log('updateMyVoucher');
			return voucherArray.map((voucher) => {
				let isUse = voucher.is_use ?? false;
				if (voucher.id === id) {
					isUse = !use;
				}
				return {
					...voucher,
					is_use: isUse,
				};
			});
		};

		const updateB2BVoucher = (voucherArray) => {
			console.log('updateB2BVoucher');
			return voucherArray.map((voucher) => {
				let totalIsUse = voucher.total_is_use || 0;
				if (voucher.code === id && type === 'plus') {
					totalIsUse += 1;
				}
				if (voucher.code === id && type === 'minus') {
					totalIsUse -= 1;
				}
				return {
					...voucher,
					total_is_use: Math.max(0, totalIsUse),
				};
			});
		};

    const updateVoucherGlobal = async (voucherArray) => {
      console.log('updateVoucherGlobal');
    
      let updatedList = await Promise.all(
        voucherArray.map(async (voucher) => {
          let validation = voucher;
          if (voucher?.purpose?.toUpperCase() === VOUCHER_GLOBAL_PURPOSE.PRODUCT) {
            validation = await validationVoucherGlobalForProduct(voucher); 
          }

          if (voucher?.purpose?.toUpperCase() === VOUCHER_GLOBAL_PURPOSE.DELIVERY && purpose?.toUpperCase() === VOUCHER_GLOBAL_PURPOSE.DELIVERY) {
            if (isEmptyData(values?.deliveryType)) {
              showError({
                title: 'Piih Pengiriman Terlebih Dahulu',
              });
              return voucher;
            };
            validation = await validationVoucherGlobalForDelivery(voucher);
          }

          let isUse = voucher.is_use ?? false;
          if (voucher.id === id) {
            isUse = !use;
          }
    
          return {
            ...voucher,
            ...validation,
            is_use: isUse,
          };
        })
      );

      const pickedByPurpose = updatedList.reduce((acc, v) => {
        if (v.is_use) {
          acc[v.purpose?.toUpperCase()] = v.id;
        }
        return acc;
      }, {});
      
      updatedList = updatedList.map(v => {
        const p = v.purpose?.toUpperCase();
        const pickedId = pickedByPurpose[p];

        // tidak ada voucher dipilih pada purpose ini
        if (!pickedId) {
          return {
            ...v,
            disabled: Boolean(v?.disabled),
          };
        }

        // voucher yang dipilih
        if (v.id === pickedId) {
          return {
            ...v,
            disabled: false,
          };
        }

        // voucher lain dengan purpose yang sama
        return {
          ...v,
          is_use: false,
          nominal_voucher: 0,
          applied_products: [],
          disabled: true,
        };
      });

      return updatedList;
    };

		if (voucher_type === 'b2b_voucher') {
			const updatedList = updateB2BVoucher(b2bVoucherList);
			setB2bVoucherList(updatedList);
		}
		if (voucher_type === 'my_voucher') {
			const updatedList = updateMyVoucher(myVoucherList);
			setMyVoucherList(updatedList);
		}
		if (voucher_type === 'voucher_global') {
			const updatedList = await updateVoucherGlobal(voucherGlobalList);
			setVoucherGlobalList(updatedList);
		}
		setDataVoucherWarning(null);
	};

	const handleGetUVBalance = () => {
		if (!user?.token || !user?.refresh_token) return;
		console.log('handleGetUVBalance');
		try {
			setIsLoadingUvBalance(true);
			const postData = {
				token: user?.token,
				refresh_token: user?.refresh_token,
			};
			const url = `ultra-value/balance`;
			axiosInstance.post(url, qs.stringify(postData), authHeaders()).then((res) => {
				if (res?.data?.status === 'ok') {
					const result = res?.data?.result?.data || {};
					setUVBalance({
						code: 'ULTRA-VOUCHER',
						name: result?.name ?? 'Ultra Value',
						value: result?.total_value ?? 0,
						image: result?.image?.url ?? '',
					});
				}
			});
			setIsLoadingUvBalance(false);
		} catch (error) {
			console.log('error: ', error);
			setIsLoadingUvBalance(false);
		}
	};

	const handleCheckPinUltraValue = async (pin = '', onValidate = false) => {
		if (!user?.token) return;
		console.log('handleCheckPinUltraValue');
		try {
			if (onValidate) {
				setIsLoading(true);
			} else {
				setIsLoadingCheckPinUltraValue(true);
			}
			const postData = {
				token: user?.token,
				pin: pin,
			};
			const url = `ultra-value/verify-pin`;
			const res = await axiosInstance.post(url, qs.stringify(postData), authHeaders());
			if (res?.data?.status === 'ok') {
				// has pin
				// "code": "CLE002",
				// "status": "error",
				// "message": "Value of PIN does not match"

				// has no pin
				// "code": "CLE011",
				// "status": "error",
				// "message": "Resource not found: PIN"

				const errorCode = res?.data?.result?.errors?.[0]?.code;
				const errorStatus = res?.data?.result?.errors?.[0]?.status;
				if (errorCode === 'CLE002' && errorStatus === 'error') {
					console.log('errorCode: ', errorCode, errorStatus);
					setIsUltraValueAvailable(true);
					if (onValidate) {
						setIsLoading(false);
						setIsInvalidPin(true);
					}
				} else {
					setIsUltraValueAvailable(false);
				}

				const successCode = res?.data?.result?.meta?.code;
				const successStatus = res?.data?.result?.meta?.status;
				if (successCode === 'SSR001' || successStatus === 'success') {
					handleCloseAndSubmitUltraValue(pin);
				}
			}
			if (!onValidate) {
				setIsLoadingCheckPinUltraValue(false);
			}
		} catch (error) {
			console.log('error: ', error);
			if (onValidate) {
				setIsLoading(false);
			} else {
				setIsLoadingCheckPinUltraValue(false);
			}
		}
	};

	const totalMyVoucherNominal = (voucherList) => {
		if (!voucherList?.length) return;
		console.log('totalMyVoucherNominal');
		const filterMyVoucher = voucherList?.filter((voucher) => voucher.is_use);
		const totalMyNominal = filterMyVoucher?.reduce((sum, voucher) => sum + voucher.nominal_voucher, 0);
		return totalMyNominal;
	};

  const totalVoucherGlobalNominal = (voucherGlobalList) => {
		if (!voucherGlobalList?.length) return;
		console.log('totalVoucherGlobalNominal');
		const filterVoucherGlobal = voucherGlobalList?.filter((voucher) => voucher.is_use);
		const totalVGNominal = filterVoucherGlobal?.reduce((sum, voucher) => sum + voucher.nominal_voucher, 0);
		return totalVGNominal;
	};

	const totalB2BVoucherNominal = (voucherList) => {
		if (!voucherList?.length) return;
		console.log('totalB2BVoucherNominal');
		let totalB2BNominal = 0;
		b2bVoucherList.forEach((voucher) => {
			if (voucher.total_is_use) {
				for (let i = 0; i < voucher.total_is_use; i++) {
					totalB2BNominal += voucher.nominal;
				}
			}
		});
		return totalB2BNominal;
	};

	const totalB2BVoucherPrice = (voucherList) => {
		if (!voucherList?.length) return;
		console.log('totalB2BVoucherPrice');
		let totalB2BPrice = 0;
		b2bVoucherList.forEach((voucher) => {
			if (voucher.total_is_use) {
				for (let i = 0; i < voucher?.total_is_use; i++) {
					totalB2BPrice += voucher?.price_user;
				}
			}
		});
		return totalB2BPrice;
	};

  const validationMultipleVoucherGlobal = (vouchers = [], data = null) => {
		if (!vouchers?.length) return [];
		console.log('validationMultipleVoucherGlobal');
    const totalUsedVoucher = vouchers.filter(v => v?.is_use === true).length;
    console.log('totalUsedVoucher: ');
    if (totalUsedVoucher > 1) {
      setIsShowWarningRedeem(true);
      setDataVoucherWarning(data);
      return setDataVoucherRedeem(vouchers);
    }
    return setVoucherGlobalList(vouchers);
  }

  const handleVerifyRedeemVoucherGLobal = (verify = false) => {
		console.log('handleVerifyRedeemVoucherGLobal');
		const redeemPurpose = cleanText(dataVoucherWarning?.purpose);
		const updatedList = dataVoucherRedeem?.map((voucher) => {
			const isCurrentVoucher = voucher?.id === dataVoucherWarning?.id;
			const voucherPurpose = cleanText(voucher?.purpose);
			if (verify) {
				if (redeemPurpose == voucherPurpose) {
					return isCurrentVoucher
						? {
								...voucher,
								is_use: true,
								disabled: false,
						}
						: {
								...voucher,
								is_use: false,
								nominal_voucher: 0,
								applied_products: [],
								disabled: true,
						};	
				} else {
					return voucher;
				}
			}

			if (isCurrentVoucher) {
				return {
					...voucher,
					is_use: false,
					nominal_voucher: 0,
					applied_products: [],
					disabled: true,
				};
			}

      return voucher;
		});

    setIsShowWarningRedeem(false);
    setDataVoucherWarning(null);
    setDataVoucherRedeem(null);
    return setVoucherGlobalList(updatedList);
  };

  const handleRedeemVoucherGlobal = async (data = null) => {
    console.log("handleRedeemVoucherGlobal");
  
    let updatedList = [...(voucherGlobalList || [])];
  
    const existsIndex = updatedList.findIndex(v => v.id === data?.id);
  
    if (existsIndex >= 0) {
      updatedList[existsIndex] = {
        ...updatedList[existsIndex],
        referral: 0,
      };
    } else {
      updatedList.push({
        ...data,
        referral: 0,
      });
    }

    if (data?.purpose === VOUCHER_GLOBAL_PURPOSE.DELIVERY && isEmptyData(values?.deliveryType)) {
      showError({
        title: 'Piih Pengiriman Terlebih Dahulu',
      });
    }
  
    let appliedVoucher = data;
    if (data?.purpose === VOUCHER_GLOBAL_PURPOSE.PRODUCT) {
      appliedVoucher = await validationVoucherGlobalForProduct(data);
    }
    if (data?.purpose === VOUCHER_GLOBAL_PURPOSE.DELIVERY && !isEmptyData(values?.deliveryType)) {
      appliedVoucher = await validationVoucherGlobalForDelivery(data);
    }

    updatedList = updatedList.map(v =>
      v?.id === data?.id ? { ...appliedVoucher, ...v} : v
    );
    
    validationMultipleVoucherGlobal(updatedList, data);
  };

  const totalNominalVoucher = useMemo(() => {
		return totalMyVoucherNominal(myVoucherList) || 0;
	}, [myVoucherList]);

  const totalNominalVoucherGlobal = useMemo(() => {
		return totalVoucherGlobalNominal(voucherGlobalList) || 0;
	}, [voucherGlobalList]);

  const totalNominalB2BVoucher = useMemo(() => {
		return totalB2BVoucherNominal(b2bVoucherList) || 0;
	}, [b2bVoucherList]);

	const totalPriceB2BVoucher = useMemo(() => {
		return totalB2BVoucherPrice(b2bVoucherList) || 0;
	}, [b2bVoucherList]);

	const maxNominalVoucher = useMemo(() => {
		let subTotal = Number(cart?.subTotal)
		if (Number(values?.deliveryType?.amount) > 0) {
			subTotal += Number(values?.deliveryType?.amount)
		}
		return Number(totalNominalVoucher) + Number(totalNominalB2BVoucher) + Number(totalNominalVoucherGlobal) > Number(subTotal) ? Number(subTotal) : Number(totalNominalVoucher) + Number(totalNominalB2BVoucher) + Number(totalNominalVoucherGlobal);
	}, [totalNominalVoucher, totalNominalB2BVoucher, totalNominalVoucherGlobal, cart?.subTotal, values?.deliveryType?.amount]);

	const remainingNominal = useMemo(() => {
		return Number(cart?.subTotal) - Number(maxNominalVoucher);
	}, [cart?.subTotal, maxNominalVoucher]);

  const paymentSummary = useMemo(() => {
		const addonPackagingFee = Number(cart?.store?.addonPackagingFee || 0);
		const minAddonPackagingFee = Number(cart?.store?.minAddonPackagingFee || 0);
		const outletPackagingFee = Number(cart?.store?.outletPackagingFee || 0);
		// const deliveryPackagingFee = Number(cart?.store?.deliveryPackagingFee || 0);
		// const pickupPackagingFee = Number(cart?.store?.pickupPackagingFee || 0);
		// const dineinPackagingFee = Number(cart?.store?.dineinPackagingFee || 0);
		const subTotal = Number(cart?.subTotal || 0);
		const platformFee = Number(cart?.platformFee || 0);
		const deliveryFee = values?.orderType === 'delivery' ? Number(values?.deliveryType?.amount || 0) + Number(values?.deliveryFee) : 0;

		let companyOnlineFee = 0;
    let onlineFee = 0;
	let packagingFee = outletPackagingFee;
    switch (cleanText(values?.orderType)) {
      case "delivery":
        companyOnlineFee = Number(cart?.onlineFeeDelivery || 0);
		// packagingFee = deliveryPackagingFee;
        break;
      case "pickup":
        companyOnlineFee = Number(cart?.onlineFeePickup || 0);
		// packagingFee = pickupPackagingFee;
        break;
      case "dinein":
        companyOnlineFee = Number(cart?.onlineFeeDinein || 0);
		// packagingFee = dineinPackagingFee;
        break;
      default:
        companyOnlineFee = 0;
        break;
    }

    if (companyOnlineFee > 0) {
      onlineFee = Math.round(subTotal * (companyOnlineFee / 100));
    }

    if(addonPackagingFee !== 0 && cart?.totalItem >= minAddonPackagingFee){
		packagingFee += calculateAddonPackagingFee(addonPackagingFee, minAddonPackagingFee, cart?.totalItem);
	}

    const isDisableVoucher = totalNominalVoucher + totalNominalB2BVoucher > subTotal;
		const fixTotalVoucherNominal = isDisableVoucher ? subTotal : maxNominalVoucher;

		const isB2BBRI =
			user?.is_b2b === true && user?.companyName?.toLowerCase() === "bri";

		let briVAPayment = null;
		if (isB2BBRI) {
			const vaCategory = paymentMethodList?.find(
				(cat) => cat?.category === 'Virtual Account'
			);

			if (vaCategory?.payment_method?.length > 0) {
				const briVA = vaCategory?.payment_method.find(
				(pm) =>
					pm?.mapping?.pg?.code === 'BRI_VA' &&
					pm?.status === 'ACTIVE'
				);

				if (briVA) {
					briVAPayment = {
						...briVA,
					};
				}
			}
		}

		let mandiriVAPayment = null;
		if (isB2BMANDIRI) {
			const vaCategory = paymentMethodList?.find(
				(cat) => cat?.category === 'Virtual Account'
			);

			if (vaCategory?.payment_method?.length > 0) {
				const mandiriVA = vaCategory?.payment_method.find(
				(pm) =>
					pm?.mapping?.pina?.code === 'VAMANDIRI' &&
					pm?.status === 'ACTIVE'
				);

				if (mandiriVA) {
					mandiriVAPayment = {
						...mandiriVA,
					};
				}
			}
		}

    const outletTax = outlet?.outlet_tax ? parseFloat(outlet?.outlet_tax) / 100 : 0;
		const outletPb1 = outlet?.outlet_pb1 ? parseFloat(outlet?.outlet_pb1) / 100 : 0;
		const tax = Math.round(subTotal * outletTax);
		const totalAfterTax = subTotal + tax;
		const pb1 = Math.round(totalAfterTax * outletPb1);

    const prevTotalPayment = subTotal + pb1 + tax + packagingFee + platformFee + deliveryFee + onlineFee + totalPriceB2BVoucher - fixTotalVoucherNominal;

		const selectedPaymentType = isB2BBRI ? briVAPayment : isB2BMANDIRI ? mandiriVAPayment : values?.paymentType;
    const feeNominal = Number(selectedPaymentType?.fee || 0);
		const feePercent = Number(selectedPaymentType?.fee_percent || 0);
		const paymentFee = Math.round(feePercent > 0 ? prevTotalPayment * (feePercent / 100) : feeNominal);
		const otherFee = packagingFee + platformFee + paymentFee + onlineFee;

		const updatePaymentFee = subTotal + packagingFee + platformFee + deliveryFee + totalPriceB2BVoucher - fixTotalVoucherNominal;

    const totalPayment = prevTotalPayment + paymentFee;

    const strikeOutTotal = cart?.item?.reduce((total, item) => {
			const itemUnitCost = Number(item?.itemUnitCost) || 0;
			const itemUnitPrice = Number(item?.itemUnitPrice) || 0;
			const itemQuantity = Number(item?.itemQuantity) || 0;

			if (item?.productType === '1') {
				return total + itemUnitCost * itemQuantity;
			}

			if (item?.productType === '2') {
				if (item?.comboset?.length === 0) {
					return total + itemUnitPrice * itemQuantity;
				}
				const comboPrice =
					item?.comboset?.reduce(
						(comboTotal, combo) =>
							comboTotal +
							(combo?.productDetails?.reduce(
								(detailTotal, detail) =>
									detailTotal +
									(Number(detail?.productPrice) || 0) *
										(Number(detail?.quantity) || 0),
								0
							) || 0),
						0
					) || 0;
				return total + comboPrice + (itemUnitCost - itemUnitPrice);
			}

			return total + itemUnitPrice * itemQuantity;
		}, 0);
    const strikeDiscount = (strikeOutTotal - subTotal) + fixTotalVoucherNominal;
    
		return {
			subTotal: subTotal,
			totalPayment: totalPayment,
			deliveryFee: deliveryFee,
			fixTotalVoucherNominal: fixTotalVoucherNominal,
			otherFee: otherFee,
			packagingFee: packagingFee,
			platformFee: platformFee,
			paymentFee: paymentFee,
			isDisableVoucher: isDisableVoucher,
			updatePaymentFee,
			tax,
			pb1,
			onlineFee,
			onlineFeePercent: companyOnlineFee,
      strikeOutTotal: strikeOutTotal,
      strikeDiscount: strikeDiscount
		};
	}, [
		cart, values?.deliveryType?.amount, values?.deliveryFee, values?.paymentType?.fee, 
		myVoucherList, b2bVoucherList, totalNominalVoucher, totalNominalB2BVoucher,
		maxNominalVoucher, outlet?.outlet_tax, outlet?.outlet_pb1, values?.orderType,
		paymentMethodList
	]);

	useEffect(() => {
		setPaymentMethodList([]);
	}, []);

	useEffect(() => {
		if (isLoadingUvBalance || isLoadingCheckPinUltraValue || !paymentSummary?.updatePaymentFee) return;
		handleGetPaymentFee();
	}, [paymentSummary?.updatePaymentFee, UVBalance?.value, isLoadingUvBalance, isLoadingCheckPinUltraValue, user?.token, paymentSummary?.paymentFee, values?.deliveryType?.amount]);

	const suggestAutoB2BVoucher = () => {
		if (!b2bVoucherList?.length || !cart?.subTotal || totalNominalB2BVoucher) return;
		console.log('suggestAutoB2BVoucher');

		let totalB2BNominal = 0;
		let totalB2BPrice = 0;

		let remainingNominal = Math.max(0, Number(cart?.subTotal) - paymentSummary?.fixTotalVoucherNominal);

		for (let b2b of b2bVoucherList) {
			let totalIsUse = 0;
			const availableStock = b2b?.total_stock_available || b2b?.stock_available || 0;
			const maxNominalUsage = Math.floor(remainingNominal / b2b.nominal);

      totalIsUse = Math.min(
        availableStock,
        maxNominalUsage,
        b2b?.max_qty ?? Number.MAX_SAFE_INTEGER
      );
      

			if (totalIsUse > 0) {
				totalB2BNominal += totalIsUse * b2b.nominal;
				totalB2BPrice += totalIsUse * b2b.price_user;
				remainingNominal -= totalIsUse * b2b.nominal;
			}
		}

		const b2BVoucherSaved = Math.max(0, totalB2BNominal - totalB2BPrice);
		return b2BVoucherSaved;
	};

	const totalSavedB2BVoucher = useMemo(() => {
		return suggestAutoB2BVoucher() || 0;
	}, [b2bVoucherList, cart?.subTotal, paymentSummary?.fixTotalVoucherNominal]);

  const getMatchedData = (method = {}, dataPg = [], dataPina = []) => {
    const mapping = method.mapping || {};
    const keys = Object.keys(mapping);

    const orderedKeys = [
      user?.paymentMethod,
      ...keys.filter(key => key !== user?.paymentMethod)
    ];

    for (const key of orderedKeys) {
      const match = mapping[key];
      if (!match) continue;
      
      const { code, source } = match;
  
      const data = source === "pina" ? dataPina[code] : source === "pg" ? dataPg[code] : null;
  
      if (data) {
        return {
          ...method,
          code,
          source,
          id: data?.id_payment_method ?? null,
          fee: data.fee ?? method.fee,
          minimum_amount: data.minimum_amount ?? method.minimum_amount,
          maximum_amount: data.maximum_amount ?? method.maximum_amount,
          status: data.status ?? method.status,
        };
      }
    }

    return null
  };

	const handleGetPaymentFee = async () => {
		try {
      setisLoadingPaymentMethodList(true);

      const isDirectBca =
        user?.is_b2b &&
        user?.paymentMethod === 'direct' &&
        user?.companyName?.toLowerCase() === 'bca';

      let mappedPinaMethods = [];

      if (!user?.is_b2b || isB2BMANDIRI) {
        const postDataPina = {
          token: user?.token,
          refresh_token: user?.refresh_token,
          totalAmount:
            paymentSummary?.totalPayment - paymentSummary?.paymentFee,
        };

        const resPina = await axiosInstance.post(
          `calculate-fee`,
          qs.stringify(postDataPina)
        );

        if (resPina?.data?.status === 'ok') {
          const pinaRaw = (resPina?.data?.data || []).flatMap((category) =>
            category?.payment_method.map((pm) => ({
              category: category?.category,
              ...pm,
			  id: category?.id,
            }))
          );

          mappedPinaMethods = pinaRaw.map((item) => {
			const uiConfig = PAYMENT_UI_CONFIG[item?.code] || {
              image_size: 'w-10 h-auto',
              image_size_payment: 'w-14 h-auto',
            };

			let type = '';

			switch (item?.category) {
				case 'Virtual Account Transfer':
					type = 'virtual_account';
					break;
				case 'QRIS':
					type = 'qris';
					break;
				default:
					type = '';
					break;
			}

            return {
              id: item?.id,
              event: `payment_methods_select_${item?.code?.toLowerCase()}`,
              code: item?.code,
              name: item?.name,
              minimum_amount: Number(item?.minimum_amount || 0),
              maximum_amount: Number(item?.maximum_amount || 0),
              status: item?.status || 'ACTIVE',
              fee: Number(item?.fee || 0),
              image_url: item?.image_url?.replace(/'/g, '') || '',
              image_size: uiConfig?.image_size,
              image_size_payment: uiConfig?.image_size_payment,
              mapping: {
                pina: {
                  source: 'pina',
                  code: item?.code,
                },
              },
              type: type,
			  source: 'pina',
            };
          });
        }
		  }

		  let mappedPgMethods = [];

		  if (user?.is_b2b && user?.paymentMethod === 'pg') {
        const resPg = await axiosInstance.get(
        `/payment-gateway/payment-methods`,
        authHeaders()
        );

        const apiData = resPg?.data?.data || [];

        mappedPgMethods = apiData.map((item) => {
          const uiConfig = PAYMENT_UI_CONFIG[item?.code] || {
            image_size: 'w-10 h-auto',
            image_size_payment: 'w-14 h-auto',
          };

          return {
            id: item?.id_payment_method,
            event: `payment_methods_select_${item?.code?.toLowerCase()}`,
            code: item?.code,
            name: item?.name,
            minimum_amount: Number(item?.minimum_amount || 0),
            maximum_amount: Number(item?.maximum_amount || 0),
            status: 'ACTIVE',
            fee: Number(item?.fee || 0),
						fee_percent: Number(item?.fee_percent || 0),
            image_url: item?.image_url?.replace(/'/g, '') || '',
            image_size: uiConfig?.image_size,
            image_size_payment: uiConfig?.image_size_payment,
            mapping: {
              pg: {
                source: 'pg',
                code: item?.code,
              },
            },
            type: item?.type,
			source: 'pg',
          };
        });
		  }

		  let finalMethods = [];

      if (isDirectBca) {
        finalMethods = [
          {
            ...vaBca,
            source: 'direct',
            id: null,
            type: 'virtual_account',
          },
        ];
      } else if (user?.is_b2b && user?.paymentMethod === 'pg') {
        finalMethods = mappedPgMethods;
      } else {
        finalMethods = mappedPinaMethods;
      }


		  let currentPaymentType = null;
		  let updatedSelectedPayment = null;

		  const updatedPaymentMethodList = listPaymentMethod?.map((category) => {
			const filteredMethods = finalMethods.filter((method) => {
				if (category.category === 'Payment Method') {
					return method.code === 'ULTRA-VOUCHER';
				}

				if (category.category === 'Other Payment Method') {
					return method.type === 'qris';
				}

				if (category.category === 'Virtual Account') {
					return method.type === 'virtual_account';
				}

				return false;
			});

			filteredMethods.forEach((method) => {
				if (!currentPaymentType && isDirectBca) {
					currentPaymentType = method;
				}

				if (!currentPaymentType && user?.is_b2b && user?.paymentMethod === 'pg') {
					currentPaymentType = method;
				}

				if (!currentPaymentType) {
					currentPaymentType = method;
				}

				if( 
					isB2BMANDIRI 
					&& method?.code == 'VAMANDIRI'
				){
					currentPaymentType = method;
				}

				if (method?.code === values?.paymentType?.code) {
					updatedSelectedPayment = method;
				}
			});

			return {
			...category,
			payment_method: filteredMethods,
			};
      }).filter((category) => category.payment_method.length);
		
      setPaymentMethodList(updatedPaymentMethodList);

      if (currentPaymentType && !defaultValues?.paymentType) {
        setDefaultValues((prev) => ({
          ...prev,
          paymentType: currentPaymentType,
        }));
      } 

	  if(updatedSelectedPayment){
		setValues((prev) => ({
          ...prev,
          paymentType: updatedSelectedPayment,
        }));
	  }

		  setisLoadingPaymentMethodList(false);
		} catch (error) {
      console.log('error: ', error);
      setisLoadingPaymentMethodList(false);
		}
	};

	const processB2BVouchers = (b2bVoucherList = []) => {
		console.log('processB2BVouchers');
		let result = [];

		b2bVoucherList.forEach((voucher) => {
			if (voucher.total_is_use) {
				for (let i = 0; i < voucher.total_is_use; i++) {
					let newVoucher = { ...voucher };
					delete newVoucher.total_is_use;
					delete newVoucher.total_stock_available;
					result.push({
						voucher_name: newVoucher?.name,
						voucher_code: newVoucher?.code,
						voucher_nominal: newVoucher?.nominal,
						voucher_price: newVoucher?.price,
						voucher_merchant_code: newVoucher?.merchant_code,
						voucher_qty: 1,
						voucher_price_user: newVoucher?.price_user,
					});
				}
			}
		});

		return result;
	};

	const handleVerifyPinUltraValue = () => {
		console.log('handleVerifyPinUltraValue');
		sendAnalyticsCustomEvent('order_history_menunggu_bayaran');
		trackMetaPixelEvent('order_history_menunggu_bayaran');
		setShowVerifyPinUltraValue(true);
	};

	const handleCloseVerifyPinUltraValue = () => {
		console.log('handleCloseVerifyPinUltraValue');
		setShowVerifyPinUltraValue(false);
    setIsUltraValueAvailable(UVBalance?.value > 0)
		setValues((prev) => {
			return {
				...prev,
				pin: null,
			};
		});

	};

	const handleCloseAndSubmitUltraValue = (pin) => {
		console.log('handleCloseAndSubmitUltraValue');
		setIsLoading(true);
		setValues((prev) => {
			return {
				...prev,
				pin: pin,
			};
		});

		setTimeout(() => {
			submitForm();
		}, 1000);
	};


  const instruction = useMemo(() => {
		const headerNote = `Proses Penyiapan Makanan: estimasi 15-25 menit.\n\n`;
		const deliveryNote = `Delivery Note:\n - No Order: ${values?.orderLocalNumber}\n\n`;
		let pickupNote = `Nota Pengambilan:\n`;
		if (cart?.store?.storeName) {
			pickupNote += `- ${cart?.store?.storeName}\n`;
		}
		if (cart?.store?.floor) {
			pickupNote += `- Ambil di Lantai ${cart?.store?.floor}\n`;
		}
		if (cart?.store?.unit) {
			pickupNote += `- Unit ${cart?.store?.unit}\n`;
		}
		pickupNote += `- Depan Kasir`;
		const menuItems = cart?.item
			?.map((item) => {
				let menuItem = `  ${item?.itemName}: ${item?.itemQuantity} quantity`;
				if (item?.comboset?.length) {
					const combo = item?.comboset?.map((comboset) => {
						const name = `\n  - ${comboset?.comboSetname}:`;
						const combo = comboset?.productDetails?.map((detail) => {
							return `\n      ${detail?.productName}`;
						});
						return `${name}${combo}`;
					});
					menuItem += `  ${combo}`;
				}
				if (item?.itemNotes) {
					menuItem += `\n  - Notes: ${item?.itemNotes}`;
				}
				return menuItem;
			})
			.join('\n');
		const customerInfo = `\n\nCustomer:\n${user?.firstName} ${user?.lastName ?? ''}\n${addCountryCode(String(user?.primary_phone))}`;
		const deliveryNotes = `${user?.detail ?? '-'} ${values?.notes ?? '-'}`;
		const notes = `*Jika tidak dapat menghubungi customer, silakan hubungi CS UFood di +62 81111801081`;
		return `${headerNote}${deliveryNote}${pickupNote}\n\nMenu Dipesan:\n${menuItems}${customerInfo}\n${deliveryNotes}\n\n${notes}`;
  }, [values, cart, user])

	const handleCreateDelivery = async () => {
		console.log('handleCreateDelivery');

		const payload = {
			unquieid: values?.unquieid,
			instantOrder: values?.instantOrder,
			availabilityID: values?.availabilityID,
			availabilityName: values?.availabilityName,
			orderSource: values?.orderSource,
			firstName: values?.destinations?.recipient?.firstName,
			email: values?.destinations?.recipient?.email,
			phone: values?.destinations?.recipient?.phone,
			lastName: values?.destinations?.recipient?.lastName,
			address: values?.destinations?.address,
			destinationDetail: values?.destinations?.recipient?.detail,
			village: values?.destinations?.village,
			district: values?.destinations?.district,
			city: values?.destinations?.city,
			state: values?.destinations?.state,
			country: values?.destinations?.country,
			latitude: values?.destinations?.coordinate?.latitude,
			longitude: values?.destinations?.coordinate?.longitude,
			postalCode: values?.destinations?.postalCode,
			billingaddress: values?.origin?.address,
			storeID: values?.origin?.storeID,
			items: (cart?.item || [])?.map((p) => p?.itemName).join(', '),
			deliveryPartner: {
				name: values?.deliveryType?.name,
				serviceType: values?.deliveryType?.serviceType,
				vehicleType: values?.deliveryType?.vehicleType,
				amount: values?.deliveryType?.amount,
				distance: values?.deliveryType?.distance,
				deliveryPartnerId: values?.deliveryType?.deliveryPartnerId,
				normal_amount: values?.deliveryType?.normal_amount,
        subsidy: values?.deliveryType?.subsidy,
			},
      deliveryFee: values?.deliveryFee,
			deliverySubsidies: values?.deliverySubsidies,
			instruction: instruction,
		};

		if (user?.is_b2b) {
			const urlDelivery = `delivery/create`;
			const orderDelivery = await axiosInstance.post(
				urlDelivery,
				JSON.stringify(payload),
				{
          baseURL: apiUrlB2B,
					headers: {
						Accept: "application/json, text/plain, */*",
						"Content-Type": "application/json",
						...authHeaders().headers
					},
				}
			);

			if (orderDelivery?.data?.status !== 'ok') {
        console.log('orderDelivery b2b: ');
				if(orderDelivery?.data?.message.toLowerCase() === "toko tutup") {
					return setShowClosed(true);
				}
        showError({
          title: orderDelivery?.data?.message,
        }).then(() => window.location.reload())
				// handleGetPathnerList();
				return setIsLoading(false);
			}
			return orderDelivery?.data?.data?.deliveryOrderID;
		} else {
			const urlDelivery = `deliverypartners/createPartnerOrder`;
			const orderDelivery = await axiosInstance.post(urlDelivery, JSON.stringify(payload), {
				headers: {
					Accept: 'application/json, text/plain, */*',
					'Content-Type': 'application/json',
          ...authHeaders().headers
				},
			});
			if (orderDelivery?.data?.status !== 'ok') {
        console.log('orderDelivery b2c: ');
				if(orderDelivery?.data?.message.toLowerCase() === "outlet already closed.") {
					return setShowClosed(true);
				}
        showError({
          title: orderDelivery?.data?.message,
        }).then(() => window.location.reload())
				// handleGetPathnerList();
				return setIsLoading(false);
			}
			return orderDelivery?.data?.deliveryOrderID;
		}
	};
  
  const handleNavigatePayment = (createPayment = null) => {
    console.log('handleNavigatePayment: ');
    const data = createPayment?.data?.data;
    const unixtime = typeof data?.expired_at === 'string' ? dateToUnix(data?.expired_at) : data?.expired_at;
    const paymentData = {
      ...data,
      session_token: createPayment?.data?.session_token || null,
      date: moment().tz("Asia/Jakarta").format("YYYY-MM-DD HH:mm:ss"),
      expired_date: unixToDate(unixtime),
      timeLeft: getSecondsLeft(unixtime),
      qr_image_url: data?.qr_image_url || null,
	  redirect_url: data?.redirect_url || null,
    };
    dispatch(
      setPayment(paymentData),
    );

    navigate.push('/payment');
  }

	const handleCreatePayment = async (deliveryOrderID = null) => {
		console.log('handleCreatePayment');
    const b2bVoucher = processB2BVouchers(b2bVoucherList);
    const myVoucher = myVoucherList?.filter((voucher) => voucher.is_use)?.map((voucher) => voucher) || [];
    const vgVoucher = voucherGlobalList?.filter((voucher) => voucher.is_use)?.map(({ terms, ...rest }) => rest) || [];

	const isB2BBRI =
      user?.is_b2b === true && user?.companyName?.toLowerCase() === "bri";

	let briVAPayment = null;

	if (isB2BBRI) {
		const vaCategory = paymentMethodList?.find(
			(cat) => cat?.category === 'Virtual Account'
		);

		if (vaCategory?.payment_method?.length > 0) {
			const briVA = vaCategory?.payment_method.find(
			(pm) =>
				pm?.mapping?.pg?.code === 'BRI_VA' &&
				pm?.status === 'ACTIVE'
			);

			if (briVA) {
				briVAPayment = {
					...briVA,
				};
			}
		}
	}

	let mandiriVAPayment = null;
	if (isB2BMANDIRI) {
		const vaCategory = paymentMethodList?.find(
			(cat) => cat?.category === 'Virtual Account'
		);

		if (vaCategory?.payment_method?.length > 0) {
			const mandiriVA = vaCategory?.payment_method.find(
			(pm) =>
				pm?.mapping?.pina?.code === 'VAMANDIRI' &&
				pm?.status === 'ACTIVE'
			);

			if (mandiriVA) {
				mandiriVAPayment = {
					...mandiriVA,
				};
			}
		}
	}

    const selectedPaymentType = isB2BBRI ? briVAPayment : 
		isB2BMANDIRI ? mandiriVAPayment :
		values?.paymentType;

    const payload = {
      unquieid: values?.unquieid,
      taxCharge: values?.taxCharge,
      taxAmount: values?.taxAmount,
      subTotal: paymentSummary?.subTotal,
      grandTotal: paymentSummary?.totalPayment,
      totalDiscount: values?.totalDiscount,
      discountType: values?.discountType,
      totalItem: cart?.item?.length || 0,
      instantOrder: values?.instantOrder,
      availabilityID: values?.availabilityID,
      availabilityName: values?.availabilityName,
      orderSource: values?.orderSource,
      firstName: values?.destinations?.recipient?.firstName,
      email: values?.destinations?.recipient?.email,
      phone: values?.destinations?.recipient?.phone,
      lastName: values?.destinations?.recipient?.lastName,
      address: values?.destinations?.address,
      destinationDetail: `${values?.destinations?.recipient?.detail || '-'} ${values?.notes ?? '-'}`,
      village: values?.destinations?.village,
      district: values?.destinations?.district,
      city: values?.destinations?.city,
      state: values?.destinations?.state,
      country: values?.destinations?.country,
      postalCode: values?.destinations?.postalCode,
      billingaddress: values?.origin?.address,
      storeID: values?.origin?.storeID,
      brandID: values?.origin?.outletBrandID,
      items: (cart?.item || [])?.map((item) => {
        return {
          itemID: item?.itemID,
          product_primary_id: item?.product_primary_id,
          product_category_id: item?.product_category_id,
          productID: item?.productID,
          itemName: item?.itemName,
          itemSKU: item?.itemSKU,
          itemImage: item?.itemImage,
          itemQuantity: item?.itemQuantity,
          itemNotes: item?.itemNotes,
          comboset: item?.comboset?.map((combo) => {
            return {
              ...combo,
              productDetails: combo?.productDetails?.map((detail) => {
                return {
                  productID: detail?.productID,
                  productName: detail?.productName,
                  productSKU: detail?.productSKU,
                  quantity: detail?.quantity,
                  product_primary_id: detail?.product_primary_id,
                };
              }),
            };
          }),
          productType: item?.productType,
        };
      }),
      deliveryPartner: {
				name: values?.deliveryType?.name,
				serviceType: values?.deliveryType?.serviceType,
				vehicleType: values?.deliveryType?.vehicleType,
				amount: values?.deliveryType?.amount,
				distance: values?.deliveryType?.distance,
				deliveryPartnerId: values?.deliveryType?.deliveryPartnerId,
				normal_amount: values?.deliveryType?.normal_amount,
        subsidy: values?.deliveryType?.subsidy
      },
      paymentFee: paymentSummary?.paymentFee || 0,
      paymentMethod: selectedPaymentType?.code || '',
      payment: selectedPaymentType,
      paymentReferenceID: values?.paymentReference,
      packagingFee: paymentSummary?.packagingFee,
      platformFee: paymentSummary?.platformFee,
      additionalDeliveryCharge: values?.additionalDeliveryCharge,
      deliveryFee: values?.deliveryFee,
      deliverySubsidies: values?.deliverySubsidies,
      token: user?.token,
      b2b_voucher: b2bVoucher,
      my_voucher: myVoucher,
      voucher_global: vgVoucher,
      pin: values?.pin || null,
      tax: paymentSummary?.tax || 0,
      pb1: paymentSummary?.pb1 || 0,
      totalPriceB2BVoucher: totalPriceB2BVoucher || 0,
      totalNominalMyVoucher: totalNominalVoucher,
      totalNominalB2BVoucher: totalNominalB2BVoucher,
      totalNominalVoucherGlobal: totalNominalVoucherGlobal,
      fixTotalVoucherNominal: paymentSummary?.fixTotalVoucherNominal || 0,
      deliveryOrderID: deliveryOrderID,
      deviceID: device?.device_id,
			onlineFee: paymentSummary?.onlineFee,
			onlineFeePercent: paymentSummary?.onlineFeePercent,
			companyName: user?.companyName,
    };

	if (user?.is_b2b && values?.orderType == 'dine in') {
	  payload.orderTableNumberID = order?.tableNumber?.id;
      payload.orderTableNumber = order?.tableNumber?.table_number;
	}

    if (values?.orderType !== "delivery") {
      delete payload.deliveryOrderID;
      delete payload.deliveryPartner;
	    payload.deliveryFee = 0;
    }

		if (user?.is_b2b && !isB2BMANDIRI) {

      if (user?.paymentMethod?.toLowerCase() === "direct") {
        ListPaymentMethodAll?.find((method) => {
          if (method?.company === user?.companyName) {
            payload.paymentMethod = method?.code;
          }
        }); 
      }

      payload.orderLocalNumber = values?.orderLocalNumber;
			const urlPayment = `payment/va`;
			const createPayment = await axiosInstance.post(
				urlPayment,
				JSON.stringify(payload),
				{
          baseURL: apiUrlB2B,
					headers: {
						Accept: "application/json, text/plain, */*",
						"Content-Type": "application/json",
						Authorization: `Bearer ${user?.token}`
					},
					validateStatus: function (status) {
						return status < 500;
					}
				}
			);

			if (createPayment?.status === 401) {
				const refreshed = await refreshTokenB2B();

				if (refreshed) {
					showError({
						title: 'Sesi Kedaluwarsa',
						message: 'Silakan refresh halaman untuk melanjutkan transaksi.',
					});
				} else {
					showError({
						title: 'Sesi Kedaluwarsa',
						message: 'Silakan login kembali untuk melanjutkan transaksi.',
					});
				}

				return setIsLoading(false);
			}

			if (createPayment?.data?.status !== 'ok') {
        console.log('createPayment b2b: ');
				if (createPayment?.data?.message?.responseMessage?.toLowerCase() === "toko tutup") {
					return setShowClosed(true);
				}
        showError({
          title: createPayment?.data?.message?.responseMessage || createPayment?.data?.message || 'Payment Failed',
        });
				return setIsLoading(false);
			}

      if (user?.paymentMethod?.toLowerCase() === "direct" && user?.companyName?.toLowerCase() === "bca") {
        const isMobile = user?.device === MOBILE;
        if (isMobile) {
          return navigate.push(`/payment-partner?transaction_id=${values?.paymentReference}`);
        } else {
          return window.parent.postMessage(
            {
              type: 'payment-partner',
              data: {
                transaction_id: `${values?.paymentReference}`,
              },
            },
            '*',
          );
        } 
      }

			if (isB2BBRI && !isEmptyData(createPayment?.data?.data?.redirect_url)) {
				return window.location.href = createPayment?.data?.data?.redirect_url;
			}
      
      return handleNavigatePayment(createPayment);
		} else {
			const urlPayment = `paymentuvcr/processPayment`;
			const createPayment = await axiosInstance.post(urlPayment, JSON.stringify(payload), {
				headers: {
					Accept: 'application/json, text/plain, */*',
					'Content-Type': 'application/json',
          ...authHeaders().headers
				},
			});
			if (createPayment?.data?.status !== 'ok' || createPayment?.data?.data?.status?.toUpperCase() === "FAILED") {
				console.log('createPayment b2c: ', createPayment);
				showError({
					title: createPayment?.data?.message?.meta?.message ?? createPayment?.data?.message ?? '',
				});
        
				return setIsLoading(false);
			}
			if (values?.paymentType.code === 'ULTRA-VOUCHER') {
				console.log('go to payment success');
				return navigate.push({
					pathname: '/payment/success',
					state: {
						payment: createPayment?.data?.data,
					},
				});
			}

			if(isB2BMANDIRI){
				return window.location.href = createPayment?.data?.data?.redirect_url;
			}
      
      return handleNavigatePayment(createPayment);
		}
	};

	const handlePayment = async () => {
		console.log('handlePayment');
		try {
			const minimum = Number(values?.paymentType?.minimum_amount);
			const maximum = Number(values?.paymentType?.maximum_amount);

			if (Number(paymentSummary?.totalPayment) < minimum && !user?.is_b2b) {
				return showError({
          title: `minimum payment is ${formatRupiah(minimum)}`,
        });
			}

			if (Number(paymentSummary?.totalPayment) > maximum && !user?.is_b2b) {
				return showError({
          title: `maximum payment is ${formatRupiah(maximum)}`,
        });
			}

			if (Number(paymentSummary?.totalPayment) < minimumAmountBca && user?.is_b2b && user?.companyName?.toLowerCase() === "bca") {
				return showError({
					title: `Pembayaran minimum ${formatRupiah(minimumAmountBca)}`,
				});
			}

			if (isNeedVerifyPinUltraValue && !values?.pin) {
				if (!isUltraValueAvailable) {
					setIsShowBottomSheet(true);
					return setIsShowSetupPin(true);
				}
				return handleVerifyPinUltraValue();
			}

			setIsLoading(true);

			sendAnalyticsCustomEvent('summary', values);
			trackMetaPixelEvent('summary', values);
      
      let deliveryOrderID = null;
      if (values?.orderType === 'delivery') {
        deliveryOrderID = await handleCreateDelivery();
      }

			await handleCreatePayment(deliveryOrderID);

			setIsLoading(false);
		} catch (error) {
			console.log('error: ', error);
      if (error?.response?.data?.message?.toLowerCase() === "toko tutup") {
        return setShowClosed(true);
      }
      showError({
        title: error?.response?.data?.message || error?.message || ''
      });
			setIsLoading(false);
		}
	};

	const handleVoucherDetail = (isShow, data, type = null) => {
		if (isShow) {
			setShowVoucherDetail({
				isOpen: true,
				data,
        type,
			});
		} else {
			setShowVoucherDetail({
				isOpen: false,
				data: null,
        type: null,
			});
		}
	};

	const groupMyForTooltip = (myVoucherList = []) => {
		if (!myVoucherList?.length) return [];
		console.log('groupMyForTooltip');
		const listUseMyVoucher = myVoucherList?.filter((voucher) => voucher.is_use) || [];

		const result = [];

		listUseMyVoucher?.forEach((voucher) => {
			const existingVoucher = result.find((v) => v.price === voucher.nominal_voucher);
			if (existingVoucher) {
				existingVoucher.total += 1;
			} else {
				result.push({
					name: voucher?.name,
					desc: 'Using the available voucher in my voucher.',
					total: 1,
					price: voucher?.nominal_voucher,
				});
			}
		});

		return result;
	};

	const groupB2BForTooltip = (b2bVoucherList = []) => {
		if (!b2bVoucherList?.length) return [];
		console.log('groupB2BForTooltip');
		const listUseB2BVoucher = b2bVoucherList?.filter((voucher) => voucher.total_is_use) || [];

		const result = [];

		listUseB2BVoucher?.forEach((voucher) => {
			const existingVoucher = result.find((v) => v.nominal === voucher.nominal);

			if (existingVoucher) {
				existingVoucher.total += voucher?.total_is_use;
			} else {
				result.push({
					name: voucher?.name,
					desc: 'Purchase voucher available at related merchants.',
					total: voucher?.total_is_use,
					nominal: voucher?.nominal,
				});
			}
		});

		return result;
	};

  const groupVGForTooltip = (voucherGlobalList = []) => {
		if (!voucherGlobalList?.length) return [];
		console.log('groupVGForTooltip');
		const listUseVoucherGlobal = voucherGlobalList?.filter((voucher) => voucher.is_use) || [];

		const result = [];

		listUseVoucherGlobal?.forEach((voucher) => {
			const existingVoucher = result.find((v) => v.code === voucher.code);

			if (existingVoucher) {
				existingVoucher.total += 1;
			} else {
				result.push({
					name: voucher?.code,
					desc: 'Using the available voucher in voucher global.',
					total: voucher?.total ?? 1,
					nominal: voucher?.nominal_voucher,
				});
			}
		});

		return result;
	};

	const tooltipVoucherList = useMemo(() => {
		const groupMyVoucher = groupMyForTooltip(myVoucherList);
		const groupB2BVoucher = groupB2BForTooltip(b2bVoucherList);
    const groupVGVoucher = groupVGForTooltip(voucherGlobalList)
		return [...groupMyVoucher, ...groupB2BVoucher, ...groupVGVoucher];
	}, [myVoucherList, b2bVoucherList, voucherGlobalList]);

	const tooltipOtherFee = useMemo(() => {
		const result = [];
		if (paymentSummary?.onlineFee) {
			result?.push({
				name: 'Online Fee',
				desc: 'Biaya pemeliharaan sistem dan layanan aplikasi untuk mendukung kelancaran operasional setiap pesanan Anda.',
				total: null,
				nominal: paymentSummary?.onlineFee,
			});
		}
		if (paymentSummary?.packagingFee) {
			result?.push({
				name: 'Packaging Fee',
				desc: 'Biaya untuk kemasan makanan dan minuman agar tetap aman, rapi, dan higienis selama proses pengemasan.',
				total: null,
				nominal: paymentSummary?.packagingFee,
			});
		}
		if (paymentSummary?.platformFee) {
			result?.push({
				name: 'Platform Fee',
				desc: 'Biaya layanan untuk mendukung operasional platform, termasuk pemprosesan pesanan dan pengembangan fitur agar pengalaman pemesanan tetap lancar.',
				total: null,
				nominal: paymentSummary?.platformFee,
			});
		}
		if (paymentSummary?.paymentFee) {
			result?.push({
				name: 'Payment Fee',
				desc: 'Biaya untuk memproses pembayaran secara aman melalui sistem pembayaran, termasuk biaya dari penyedia layanan pembayaran.',
				total: null,
				nominal: paymentSummary?.paymentFee,
			});
		}
		return result;
	}, [paymentSummary?.paymentFee, paymentSummary?.platformFee, paymentSummary?.packagingFee, paymentSummary?.onlineFee]);

	const strikeOutTotalPayment = useMemo(() => {
		// other fee = packagingFee + platformFee + paymentFee
    if (paymentSummary?.strikeOutTotal > 0) {
		  return Number(paymentSummary?.subTotal) + Number(paymentSummary?.otherFee) + Number(paymentSummary?.deliveryFee) + Number(paymentSummary?.tax) + Number(paymentSummary?.pb1) + (Number(paymentSummary?.strikeOutTotal) - Number(paymentSummary?.subTotal))
    } else {
      return Number(paymentSummary?.subTotal) + Number(paymentSummary?.otherFee) + Number(paymentSummary?.deliveryFee) + Number(paymentSummary?.tax) + Number(paymentSummary?.pb1)
    };
	}, [paymentSummary?.subTotal, paymentSummary?.otherFee, paymentSummary?.deliveryFee, paymentSummary?.strikeDiscount]);

	const isNeedVerifyPinUltraValue = useMemo(() => {
		return values?.paymentType?.code === 'ULTRA-VOUCHER';
	}, [values?.paymentType?.code]);

	const isLowBalanceUltraValue = useMemo(() => {
		return Number(UVBalance?.value ?? 0) < Number(paymentSummary?.totalPayment ?? 0);
	}, [UVBalance?.value, paymentSummary?.totalPayment]);

	const isDisableUltraValue = useMemo(() => {
		if(isB2BMANDIRI) return false;
			
		return isNeedVerifyPinUltraValue && isLowBalanceUltraValue;
	}, [isNeedVerifyPinUltraValue, isLowBalanceUltraValue]);

	const handleCloseBottomSheet = () => {
		console.log('handleCloseBottomSheet');
		setIsShowBottomSheet(false);
		setIsShowDelivery(false);
		setIsShowPaymentMethod(false);
		setIsShowSimpleProduct(false);
		setIsShowComboProduct(false);
		setIsShowVoucher(false);
		setIsShowMoreVoucher(false);
		setIsShowDeliveryLocation(false);
		setIsTooFar(false);
		setIsShowSetupPin(false);
		setIsShowTutor(false);

		document.body.style.overflow = '';
	};

	const handleShowTutor = () => {
		setIsShowTutor(true);
		setIsShowBottomSheet(false);
	};

	useEffect(() => {
		const handleMessage = (event) => {
			if (event.data?.type === 'payment-partner') {
				console.log('event: ', event);
			}
		};

		window.addEventListener('message', handleMessage);

		return () => {
			window.removeEventListener('message', handleMessage);
		};
	}, []);


  useEffect(() => {
    const unsubscribe = subscribeError(setErrorOpen);
    return unsubscribe;
  }, []);
  
	const handleOpenDelivery = () => {
		setIsOpenDelivery(true);
	};

	const handleCloseDelivery = () => {
		setIsOpenDelivery(false);
	};

	const deliveryProps = useMemo(() => {
		return {
      isOpenDelivery,
			onClose: handleCloseDelivery,
      handleOpen: handleOpenDelivery,
      errors,
      touched, 
      values,
		};
	}, [isOpenDelivery, errors, touched, values]);

  const checkoutSliderProps = {
    isShow: cart && !isShowBottomSheet && !isShowWarningVoucher && !isShowWarningRedeem && !isOpenDelivery && !isShowConfirmation,
    handleSubmit: submitForm,
    amount: formatRupiah(parseInt(paymentSummary?.totalPayment || 0)),
  }

	const refreshTokenB2B = async () => {
		try {
			const token = user?.refresh_token;
			if (!token) {
				return false;
			}

			const response = await axiosInstance.post(
				'auth/refresh',
				{},
				{
					baseURL: apiUrlB2B,
					headers: {
						Accept: 'application/json, text/plain, */*',
						'Content-Type': 'application/json',
						'refresh-token': token,
					},
					validateStatus: (status) => status < 500,
				},
			);

			const newAccessToken = response?.data?.accessToken;

			if (response?.status === 200 && newAccessToken) {
				dispatch(
					setUser({
						...user,
						token: newAccessToken,
					}),
				);

				return true;
			}
			return false;
		} catch (error) {
			console.log('refresh token error:', error);
			return false;
		}
	};

	return (
		<>
			{isLoading && <Loader overlay />}
			{isShowVerifyPinUltraValue && (
				<VerifyPin onClose={handleCloseVerifyPinUltraValue} onSubmit={(pin, onValidate) => handleCheckPinUltraValue(pin, onValidate)} isInvalid={isInvalidPin} onClear={() => setIsInvalidPin(false)} isLoading={isLoading} />
			)}
			{isShowTutor && <HowToSetPinUltraValue onBack={handleCloseBottomSheet} onSubmit={handleCloseBottomSheet} />}
			<div className={`${isShowVerifyPinUltraValue || isShowTutor ? 'hidden' : 'flex'} h-screen w-full justify-center items-center bg-white`}>
				<div className='relative h-screen w-full max-w-lg'>
					<div className={`absolute mt-4 w-full`}>
						<Header outlet={outlet} cart={cart} handleFavorite={handleFavorite} />
						<OrderOption 
							isDisabled={isLoading || isLoadingDeliveryList} 
							setValues={setValues} 
							setDefaultValues={setDefaultValues} 
							outletId={cart?.store?.storeID} 
							isShowConfirmation={isShowConfirmation}
							setIsShowConfirmation={setIsShowConfirmation} 
						/>
            <OutletDetail values={values} />
						<DeliveryOption {...deliveryProps} />
						<NotesOption values={values} setValues={setValues} />
						<PathnerOption
							selectedPathner={selectedPathner}
							errors={errors}
							touched={touched}
							values={values}
							isLoadingDeliveryList={isLoadingDeliveryList}
							setValues={setValues}
							setIsShowDelivery={setIsShowDelivery}
							setIsShowBottomSheet={setIsShowBottomSheet}
						/>
						<ProductOption cart={cart} handleGetProductDetail={handleGetProductDetail} handleCart={handleCart} outlet={outlet} user={user} />
						<VoucherOption
							isLoadingVoucherList={isLoadingVoucherList}
							maxNominalVoucher={maxNominalVoucher}
							totalSavedB2BVoucher={totalSavedB2BVoucher}
							handleApplyB2BVoucher={handleApplyB2BVoucher}
							isLoading={isLoading}
							totalNominalVoucher={totalNominalVoucher}
							totalNominalB2BVoucher={totalNominalB2BVoucher}
							totalNominalVoucherGlobal={totalNominalVoucherGlobal}
							setIsShowBottomSheet={setIsShowBottomSheet}
							setIsShowVoucher={setIsShowVoucher}
						/>
						<PaymentOption
							isLoadingPaymentMethodList={isLoadingPaymentMethodList}
							isLoadingUvBalance={isLoadingUvBalance}
							isLoadingCheckPinUltraValue={isLoadingCheckPinUltraValue}
							isDisableUltraValue={isDisableUltraValue}
							isNeedVerifyPinUltraValue={isNeedVerifyPinUltraValue}
							values={values}
							UVBalance={UVBalance}
							setIsShowPaymentMethod={setIsShowPaymentMethod}
							setIsShowBottomSheet={setIsShowBottomSheet}
						/>
						<PaymentSummaryOption
              values={values}
							paymentSummary={paymentSummary}
							tooltipOtherFee={tooltipOtherFee}
							totalNominalB2BVoucher={totalNominalB2BVoucher}
							tooltipVoucherList={tooltipVoucherList}
							maxNominalVoucher={maxNominalVoucher}
							totalPriceB2BVoucher={totalPriceB2BVoucher}
							strikeOutTotalPayment={strikeOutTotalPayment}
						/>
					</div>
					{isShowBottomSheet && (
						<BottomSheet
							open={isShowBottomSheet}
							onDismiss={handleCloseBottomSheet}
							blocking={isShowWarningVoucher || isShowWarningRedeem || errorOpen ? false : true}
							snapPoints={({ minHeight, maxHeight }) => {
								// 544 932
								if (isShowDeliveryLocation) {
									return [maxHeight - maxHeight / 10];
								}
								return [minHeight, maxHeight * 0.75];
							}}
							header={() => {
								return null;
							}}
							footer={
								isShowVoucher ? (
									<button
										id='voucher_submit'
										className='w-full bg-[var(--rose-violet)] text-white flex justify-center font-normal text-sm border-0 items-center p-3 rounded-lg'
										onClick={() => {
											handleCloseBottomSheet();
										}}>
										Simpan
									</button>
								) : null
							}>
							{isShowSimpleProduct && <ProductSimple product={cartItem} cart={cart} handleCart={handleCart} setCartItem={setCartItem} />}
							{isShowComboProduct && <ComboDetail product={product} item={item} handleSubmitItem={handleCart} isEdit={true} />}
							{isShowDelivery && (
								<div className={`bg-white p-4 shadow-custom transition-transform duration-1000 ease-in-out rounded-t-xl ${isShowDelivery ? 'translate-y-0 relative' : 'translate-y-full hidden'}`}>
									<div className='flex justify-center py-4 text-base text-gray-900 font-semibold'>Layanan Antar</div>
									{pathnerList?.map((pathner, index) => {
										return (
											<div
												key={`pathner_${index}`}
												className={`border-1 border-gray-300 border-solid rounded-md flex justify-between px-2 py-2.5 mt-2 items-center`}
												onClick={() => {
													setSelectedPathner(pathner);
													sendAnalyticsEvent('Select Delivery', 'summary_select_delivery', pathner?.name);
													if (pathner?.vehicle?.length === 1) {
														setValues((prev) => {
															return {
																...prev,
																deliveryType: pathner?.vehicle?.[0] || null,
															};
														});
													}
												}}>
												<div className=''>
													<div className={`text-sm capitalize text-gray-900 font-semibold`}>{`${pathner?.name} ${pathner?.serviceType}`}</div>
													<div className='text-xs text-gray-400 pt-1 font-thin'>Perkiraan tiba 20-30 menit</div>
												</div>
												<div className='flex'>
                          <div className={`pl-2 text-gray-900 font-semibold text-sm`}>
                            {formatRupiah((pathner?.vehicle?.[0]?.amount || 0))}
                          </div>
													<div className='pl-2'>
														<input
															id='pathner'
															type='radio'
															name='pathner'
															value={pathner?.name}
															checked={selectedPathner?.name === pathner?.name}
															onChange={() => null}
															className={`${
																selectedPathner?.name === pathner?.name ? '!border-[var(--rose-violet)]' : '!border-gray-400'
															} after:!bg-[var(--rose-violet)] active:bg-white !focus:ring-0 !focus:bg-transparent focus:shadow-none`}
														/>
													</div>
												</div>
											</div>
										);
									})}
									<button
										id='summary_confirm_delivery'
										className='mt-10 w-full bg-[var(--rose-violet)] text-white flex justify-center font-normal text-sm p-3 border-0 items-center'
										onClick={() => {
											setIsShowDelivery(false);
											setIsShowBottomSheet(false);
										}}>
										Pilih
									</button>
								</div>
							)}
							{isShowPaymentMethod && (
								<PaymentMethod
									isShowPaymentMethod={isShowPaymentMethod}
									paymentMethodList={paymentMethodList}
									setIsShowPaymentMethod={setIsShowPaymentMethod}
									setIsShowBottomSheet={setIsShowBottomSheet}
									isLowBalanceUltraValue={isLowBalanceUltraValue}
									isLoadingCheckPinUltraValue={isLoadingCheckPinUltraValue}
									values={values}
									setValues={setValues}
									UVBalance={UVBalance}
								/>
							)}
							{isShowVoucher && (
								<>
									<div className={`bg-white transition-transform duration-1000 ease-in-out rounded-t-xl h-full relative ${isShowVoucher ? 'translate-y-0 relative' : 'translate-y-full hidden'}`}>
										<div className='flex justify-start py-4 text-base text-gray-900 font-semibold mx-4'>Tambah Voucher</div>
										<div className='border-b-1 border-solid border-gray-200 mb-4' />
                    <PromoCode onSubmit={(data) => handleRedeemVoucherGlobal(data)} cart={cart} totalOrder={totalOrder} />
										<div className='h-full overflow-y-scroll overflow-x-hidden scrollbar-hide '>
											<div className={`mt-4 h-full`}>
												<div className='text-base font-semibold text-gray-900 mx-4'>Voucher Saya</div>
												{voucherGlobalList?.map((voucher, index) => {
                          return (
                            <VoucherGlobal
                              key={`voucher_global_${index}`}
                              showLabelCount={false}
                              type={'my_voucher'}
                              data={voucher}
                              handleUseVoucher={(data, type, warning) => {
                                if (warning) {
                                  setDataVoucherWarning({
                                    code: data?.code,
                                    voucher_type: 'voucher_global',
                                    is_use: data.is_use ?? false,
                                    type: type,
                                  });
                                  setIsShowWarningVoucher(true);
                                } else {
                                  handleUpdateVoucherList(data.id, 'voucher_global', data.is_use ?? false, null, data?.purpose);
                                }
                              }}
                              remainingNominal={remainingNominal}
                              onOpenDetail={(type) => {
                                handleVoucherDetail(true, voucher, type);
                              }}
                              isDisabled={voucher?.disabled}
                              {...{values}}
                            />
                          );
												})}
												{!isShowMoreVoucher
													? myVoucherList?.slice(0, 3)?.map((voucher, index) => {
															return (
																<Voucher
																	key={`my_voucher_all_${index}`}
																	showLabelCount={false}
																	type={'my_voucher'}
																	data={voucher}
																	handleUseVoucher={(data, type, warning) => {
																		if (warning) {
																			setDataVoucherWarning({
																				code: data?.code,
																				voucher_type: 'my_voucher',
																				is_use: data.is_use ?? false,
																				type: type,
																			});
																			setIsShowWarningVoucher(true);
																		} else {
																			handleUpdateVoucherList(data.id, 'my_voucher', data.is_use ?? false, null);
																		}
																	}}
																	remainingNominal={remainingNominal}
																	onOpenDetail={() => handleVoucherDetail(true, voucher)}
																/>
															);
													  })
													: myVoucherList?.map((voucher, index) => {
															return (
																<Voucher
																	key={`my_voucher_all_${index}`}
																	showLabelCount={false}
																	type={'my_voucher'}
																	data={voucher}
																	handleUseVoucher={(data, type, warning) => {
																		if (warning) {
																			setDataVoucherWarning({
																				code: data?.code,
																				voucher_type: 'my_voucher',
																				is_use: data.is_use ?? false,
																				type: type,
																			});
																			setIsShowWarningVoucher(true);
																		} else {
																			handleUpdateVoucherList(data.id, 'my_voucher', data.is_use ?? false, null);
																		}
																	}}
																	remainingNominal={remainingNominal}
																	onOpenDetail={() => handleVoucherDetail(true, voucher)}
																/>
															);
													  })}
												<div className={`${myVoucherList?.length <= 3 && 'hidden'}`}>
													{!isShowMoreVoucher ? (
														<div
															className={`flex mt-6 justify-center items-center text-green-600 text-sm font-semibold w-full`}
															onClick={() => {
																console.log('onClick more voucher');
																setIsShowMoreVoucher(true);
															}}>
															Lihat Lebih Banyak
															<ChevronDownIcon class='h-5 w-5 text-green-600' strokeWidth={3} />
														</div>
													) : (
														<div
															className={`flex mt-6 justify-center items-center text-green-600 text-sm font-semibold w-full`}
															onClick={() => {
																console.log('onClick more voucher');
																setIsShowMoreVoucher(false);
															}}>
															Lihat Lebih Sedikit
															<ChevronUpIcon class='h-5 w-5 text-green-600' strokeWidth={3} />
														</div>
													)}
												</div>
												<div className={`my-8 flex flex-col items-center ${(!isEmptyData(myVoucherList) || !isEmptyData(voucherGlobalList)) && 'hidden'}`}>
													<div className='text-gray-900 font-semibold text-base'>Kamu tidak memiliki voucher</div>
													<div className='text-gray-900 font-thin text-xs'>Jangan lewatkan! Beli voucher untuk diskon</div>
												</div>
												<div className='border-b-8 border-solid pb-5 border-gray-200 w-screen' />
												<div className={`${b2bVoucherList?.length ? 'mb-5' : ''}`}>
													<div className='text-base font-semibold text-gray-900 mt-6 mx-4'>Voucher lainnya dari UFood</div>
													{b2bVoucherList?.length ? (
														b2bVoucherList?.map((voucher, index) => {
															return (
																<Voucher
																	key={`b2b_voucher_all_${index}`}
																	showLabelCount={false}
																	type={'b2b_voucher'}
																	data={voucher}
																	isDisabled={voucher?.disabled ?? false}
																	handleUseVoucher={(data, type, warning) => {
																		const totalRestrictedVoucher = b2bVoucherList.reduce(
																			(sum, voucher) => {
																			if (voucher?.max_qty === 3) {
																				return sum + Number(voucher?.total_is_use || 0);
																			}
																			return sum;
																			},
																			0
																		);

																		if (
																			type === 'plus' &&
																			data?.max_qty === 3 &&
																			totalRestrictedVoucher >= 3
																		) {
																			showError({
																				title: 'Maaf, penggunaan voucher dibatasi maksimal 3 voucher per transaksi untuk setiap akun pengguna.',
																			});
																			return;
																		}

																		if (warning) {
																			setDataVoucherWarning({
																				code: data.code,
																				voucher_type: 'b2b_voucher',
																				is_use: data.is_use ?? false,
																				type: type,
																			});
																			setIsShowWarningVoucher(true);
																		} else {
																			handleUpdateVoucherList(data.code, 'b2b_voucher', data.is_use ?? false, type);
																		}
																	}}
																	remainingNominal={remainingNominal}
																	onOpenDetail={() => handleVoucherDetail(true, voucher)}
																/>
															);
														})
													) : (
														<div className='my-8 flex flex-col items-center'>
															<div className='text-gray-900 font-semibold text-base'>Kamu tidak memiliki voucher</div>
															<div className='text-gray-900 font-thin text-xs'>Jangan lewatkan! Beli voucher untuk diskon</div>
														</div>
													)}
												</div>
											</div>
										</div>
									</div>
									{showVoucherDetail.isOpen && isEmptyData(showVoucherDetail.type) && <VoucherDetail data={showVoucherDetail.data} onClose={() => handleVoucherDetail(false)} />}
									{showVoucherDetail.isOpen && !isEmptyData(showVoucherDetail.type) && <VoucherGlobalDetail data={showVoucherDetail.data} onClose={() => handleVoucherDetail(false)} />}
								</>
							)}
							{isTooFar && <TooFar show={isTooFar} handleClickButton={handleCloseBottomSheet} />}
							{isShowSetupPin && <SetPinUltraValue onSubmit={handleShowTutor} />}
						</BottomSheet>
					)}
					{isShowWarningVoucher && (
						<Footer position='fixed' id='verify-voucher' className={`h-full`}>
							<VerifyVoucher
								onSubmit={() => {
									console.log('onSubmit');
									handleUpdateVoucherList(dataVoucherWarning?.code, dataVoucherWarning?.voucher_type, dataVoucherWarning?.is_use, dataVoucherWarning?.type);
									setIsShowWarningVoucher(false);
								}}
								onCancel={() => {
									console.log('onCancel');
									setDataVoucherWarning(null);
									setIsShowWarningVoucher(false);
								}}
							/>
						</Footer>
					)}
					{isShowWarningRedeem && (
						<Footer position='fixed' id='verify-voucher' className={`h-full`}>
							<VerifyVoucher
								onSubmit={() => {
									console.log('onSubmit');
									handleVerifyRedeemVoucherGLobal(true);
								}}
								onCancel={() => {
									console.log('onCancel');
									handleVerifyRedeemVoucherGLobal(false);
								}}
                title="Apakah anda yakin ingin menggunakan voucher ini ?"
							/>
						</Footer>
					)}
					<CheckoutSlider { ...checkoutSliderProps }/>
					{showClosed && (
						<OutletClosedCard open={showClosed} onBackHome={() => navigate.push('/') } />
					)}
				</div>
			</div>
		</>
	);
};

export default Summary;